<template>
    <!-- 库存管理 板材库 -->
    <div class="templete">
        <div class="search_box search_box_f no_print clearfix">
            <div class="search_time search_inputBox">
                <el-date-picker v-model="start_time" type="date" @keyup.enter.native="getList(true)" placeholder="开始日期" size="mini"></el-date-picker>
            </div>
            <div class="search_time search_inputBox">
                <el-date-picker v-model="end_time" type="date" @keyup.enter.native="getList(true)" placeholder="结束日期" size="mini"></el-date-picker>
            </div>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-model="params.bale_no" placeholder="捆包号"></el-input>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-model="params.contract_no" placeholder="合同号"></el-input>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.breed_id" multiple collapse-tags placeholder="品名" filterable @visible-change="getSelectWarehouseList('breed_id')">
                <el-option v-for="list in selectMapC.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" filterable @visible-change="getSelectWarehouseList('brand_id')">
                <el-option v-for="list in selectMapC.brand_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.thickness" multiple collapse-tags placeholder="厚度" filterable @visible-change="getSelectWarehouseList('original_thickness')">
                <el-option v-for="(list,index) in selectMapC.original_thickness" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.length" multiple collapse-tags placeholder="长度" filterable @visible-change="getSelectWarehouseList('original_length')">
                <el-option v-for="(list,index) in selectMapC.original_length" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.grade_id" multiple collapse-tags placeholder="等级" filterable @visible-change="getSelectWarehouseList('grade_id')">
                <el-option v-for="list in selectMapC.grade_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.warehouse_id" multiple collapse-tags placeholder="仓库" filterable @visible-change="getSelectWarehouseList('warehouse_id')">
                <el-option v-for="list in selectMapC.warehouse_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.original_bale" placeholder="供单号" size="mini"></el-input>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.status" multiple collapse-tags placeholder="销售状态" filterable @visible-change="getSelectWarehouseList('status')">
                <el-option v-for="(list,index) in selectMapC.status" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.bale_status" multiple collapse-tags placeholder="资源状态" filterable @visible-change="getSelectWarehouseList('bale_status')">
                <el-option v-for="(list,index) in selectMapC.bale_status" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <div class="search_time search_inputBox" v-if="isShowMore">
                <el-input v-model="params.price_min" @keyup.enter.native="getList(true)" placeholder="价格区间" size="mini"></el-input>
                ~
                <el-input v-model="params.price_max" @keyup.enter.native="getList(true)" placeholder="价格区间" size="mini"></el-input>
            </div>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.opening_company_id" placeholder="货权单位" filterable @visible-change="getSelectWarehouseList('opening_company_id')">
                <el-option v-for="list in selectMapC.opening_company_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.supplier_id" multiple collapse-tags placeholder="供应商" filterable @visible-change="getSelectWarehouseList('supplier_id')">
                <el-option v-for="list in selectMapC.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.attribute_id" multiple collapse-tags placeholder="属性" @visible-change="getSelectWarehouseList('attribute_id')">
                <el-option v-for="list in selectMapC.attribute_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.color_id" multiple collapse-tags placeholder="选色" filterable @visible-change="getSelectWarehouseList('color_id')">
                <el-option v-for="list in selectMapC.color_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.place_origin" multiple collapse-tags placeholder="产地" filterable @visible-change="getSelectWarehouseList('place_origin')">
                <el-option v-for="list in selectMapC.place_origin" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <!-- <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.place_origin" placeholder="产地"></el-input> -->
            <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.expiry_time" placeholder="到期日"></el-input>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.redemption_day" placeholder="赎单日"></el-input>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.storage_age_start" placeholder="库龄开始"></el-input>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.storage_age_end" placeholder="库龄结束"></el-input>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.check_status" placeholder="检尺状态">
                <el-option :value="999" label="全部检尺状态"></el-option>
                <el-option :value="1" label="已检尺"></el-option>
                <el-option :value="0" label="未检尺"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.category" placeholder="库存类型" filterable>
                <el-option v-for="list in categoryList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.bill_lading_no" placeholder="提单号"></el-input>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.container_no" placeholder="货柜号"></el-input>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.storage_location" placeholder="库位号"></el-input>
            <!-- <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.ship_no" placeholder="船名"></el-input>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.batch_no" placeholder="批次号"></el-input>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.heap_no" placeholder="堆号"></el-input> -->
            <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.remark" placeholder="备注"></el-input>
            <div class="search_time search_inputBox" v-if="isShowMore">
                <el-date-picker v-model="start_out_time" type="date" @keyup.enter.native="getList(true)" placeholder="开始出库日期" size="mini"></el-date-picker>
                ~
                <el-date-picker v-model="end_out_time" type="date" @keyup.enter.native="getList(true)" placeholder="结束出库日期" size="mini"></el-date-picker>
            </div>
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                <div class="reset fcolor" style="margin: 0 20px;">
                    <el-checkbox v-model="is_like">精确查找</el-checkbox>
                </div>
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <span class="excel_btn" @click="exportExcelBill" v-if="module.indexOf(',warehouse-statistic-export,')!=-1"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="btnList no_print clearfix">
            <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="module.includes(',warehouse-statistic-checkruler,')" @click="chi">检尺</el-button>
            <el-button class="funcPublicBtn" v-if="module.includes(',warehouse-statistic-proportion,')" @click="batchPerEdit">修改百分比</el-button>
            <el-button class="funcPublicBtn" v-if="module.includes(',warehouse-statistic-label,')" @click="printTip">标签</el-button>
            <el-button class="funcPublicBtn" v-if="module.includes(',warehouse-statistic-edit,')" @click="batchEdit">批量修改</el-button>
            <el-button class="funcPublicBtn" v-if="module.includes(',warehouse-statistic-delete,')" @click="batchDel">批量删除</el-button>
            <el-button class="funcPublicBtn" v-if="module.includes(',warehouse-sheet-list,')" @click="batchOriginal">码单管理</el-button>
            <!-- <el-button class="funcPublicBtn" v-if="module.includes(',warehouse-sheet-list,')" @click="originalPrint(0)">原码单打印</el-button> -->
            <!-- <el-button class="funcPublicBtn" v-if="module.includes(',warehouse-sheet-list,')" @click="originalPrint(1)">自码单打印</el-button> -->
            <el-button class="funcPublicBtn" v-if="module.includes(',warehouse-sheet-list,')" @click="printOpen">码单打印</el-button>
            <el-button class="funcPublicBtn" v-if="module.includes(',warehouse-sheet-list,')" @click="printManage">打印管理</el-button>
            <div class="execlInsertBtn" v-if="module.includes(',warehouse-import,')" @click="importDialogVisible=!importDialogVisible">
                <span class="excel_btn"><i class="excel-icon"></i>期初导入</span>
            </div>
            <div class="upimgBtnBox" v-if="module.includes(',inventory-upload-files,')" @click="bacthUpFile">
                <div class="upFileBtnImg"></div>
                <div class="upimgBtnTitle">上传文件</div>
            </div>
            <div class="upimgBtnBox" v-if="module.includes(',inventory-upload-images,')" @click="bacthUpImg">
                <div class="upimgBtnImg"></div>
                <div class="upimgBtnTitle">上传图片</div>
            </div>
        </div>
        <div class="tableBox no_print">
            <tabletem :isSetCol="true" :isLoading="tableLoading" :isShowIndex="true" :operationWidth="95" scene="inventory.statistic" 
            :tablecol="tableCol" :tabledata="list"  @sortTable="sortTable" @relativefile="relativeFile" @getRow="getRow"  @recall="recall" @seeSaleBill="seeSaleBill" @hoverClick="hoverClick" @getTableDelete="getTableDelete" @dialogViewClick="dialogViewClick" @getTableEdit="getTableEdit" @rowClick="rowClick"></tabletem>
        </div>
        <div class="totalCal no_print">
            <div class="totalNumber" v-if="totalObj.original_cube||Number(totalObj.original_cube)===0">码单立方:{{totalObj.original_cube}}</div>
            <div class="totalNumber" v-if="totalObj.sales_cube||Number(totalObj.sales_cube)===0">
                <div class="contractLabel" style="position:relative;">
                    <div class="labelTip" style="width:120px;left:0px;">
                        <div class="laCbelTipC">
                            销售立方
                        </div>
                    </div>
                    <span>库存立方:{{totalObj.sales_cube}}</span>
                </div>
            </div>
            <div class="totalNumber" v-if="totalObj.check_cube||Number(totalObj.check_cube)===0">检尺立方:{{totalObj.check_cube}}</div>
            <div class="totalNumber" v-if="totalObj.purchase_amount||Number(totalObj.purchase_amount)===0">
                <div class="contractLabel" style="position:relative;">
                    <div class="labelTip">
                        <div class="laCbelTipC" >
                            采购单价*码单立方
                        </div>
                    </div>
                    <span>码单金额:{{totalObj.purchase_amount}}</span>
                </div>
            </div>
            <div class="totalNumber" v-if="totalObj.sales_price||Number(totalObj.sales_price)===0">
                <div class="contractLabel" style="position:relative;">
                    <div class="labelTip">
                        <div class="laCbelTipC" >
                            销售立方*挂牌价
                        </div>
                    </div>
                    <span>库存金额:{{totalObj.sales_price}}</span>
                </div>
            </div>
            <div class="totalNumber" v-if="totalObj.cost||Number(totalObj.cost)===0">
                <div class="contractLabel" style="position:relative;">
                    <div class="labelTip" style="width:210px;">
                        <div class="laCbelTipC" >
                            费用平摊单价*码单立方
                        </div>
                    </div>
                    <span>费用金额:{{totalObj.cost}}</span>
                </div>
            </div>
            <div class="totalNumber" v-if="totalObj.warehouse_amount||Number(totalObj.warehouse_amount)===0">
                <div class="contractLabel" style="position:relative;">
                    <div class="labelTip" style="width:210px;">
                        <div class="laCbelTipC" >
                            仓储费单价*码单立方
                        </div>
                    </div>
                    <span>仓储费金额:{{totalObj.warehouse_amount}}</span>
                </div>
            </div>
            <!-- <div class="totalNumber" v-if="totalObj.warehouse_amount||Number(totalObj.warehouse_amount)===0">仓储费金额:{{totalObj.warehouse_amount}}</div> -->
            <div class="totalNumber">选中件数: {{selectRow.length}}</div>
            <div class="totalNumber">选中立方: {{selectCube}}m³</div>
        </div>
        <div class="pageBox no_print">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <!-- 修改库存START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogA" width="630px" :modal="false" title="修正原始码单数据" custom-class="full_dialog">
            <el-form  ref="editForm" :model="editForm" class="clearfix">
                <div class="eldialogFormBox">
                    <el-form-item  label="入库日期：" prop="inbound_time">
                        <el-date-picker v-model="editForm.inbound_time" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="供应商：" prop="supplier_id">
                        <el-select v-model="editForm.supplier_id" clearable @visible-change="getSelectList('supplier')" filterable>
                            <el-option v-for="list in selectMap.supplier" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="品名：" prop="breed_id">
                        <el-select v-model="editForm.breed_id" clearable @change="changesaleBreed()" @visible-change="getSelectList('breed')" :disabled="editStockLimit">
                            <el-option v-for="list in selectMap.breed" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="品牌：" prop="brand_id">
                        <el-select v-model="editForm.brand_id" clearable @visible-change="getSelectList('brand')" :disabled="editStockLimit">
                            <el-option v-for="list in selectMap.brand" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="厚度：" prop="original_thickness">
                        <el-input v-model="editForm.original_thickness" :disabled="editStockLimit||mixedBag"></el-input>
                    </el-form-item>
                    <el-form-item  label="长度：" prop="original_length">
                        <el-input v-model="editForm.original_length" :disabled="editStockLimit||mixedBag"></el-input>
                    </el-form-item>
                    <el-form-item  label="厚度mm：" prop="thickness_formula">
                        <el-input v-model="editForm.thickness_formula" :disabled="editCategory||mixedBag"></el-input>
                    </el-form-item>
                    <el-form-item  label="长度m：" prop="length_formula">
                        <el-input v-model="editForm.length_formula" :disabled="editCategory||mixedBag"></el-input>
                    </el-form-item>
                    <el-form-item  label="片数：" prop="pieces">
                        <el-input v-model="editForm.pieces" :disabled="editStockLimit||mixedBag"></el-input>
                    </el-form-item>
                    <el-form-item  label="等级：" prop="grade_id">
                        <el-select v-model="editForm.grade_id" @visible-change="getSelectList('grade')" :disabled="editStockLimit">
                            <el-option v-for="list in selectMap.grade" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="码单立方：" prop="original_cube">
                        <el-input v-model="editForm.original_cube" :disabled="editStockLimit||batchFlag||originalGraying"></el-input>
                    </el-form-item>
                    <el-form-item  label="挂牌价：" prop="sales_price">
                        <el-input v-model="editForm.sales_price"></el-input>
                    </el-form-item>
                    <el-form-item  label="币种：" prop="foreign_currency_id">
                        <el-select v-model="editForm.foreign_currency_id" @visible-change="getSelectList('currency')">
                            <el-option v-for="list in selectMap.currency" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="外币单价：" prop="foreign_currency_price" v-if="module.indexOf(',warehouse-statistic-cost,')!=-1">
                        <el-input v-model="editForm.foreign_currency_price"></el-input>
                    </el-form-item>
                    <el-form-item  label="采购单价：" prop="cube_price" v-if="module.indexOf(',warehouse-statistic-cost,')!=-1">
                        <el-input v-model="editForm.cube_price" :disabled="editStockLimit"></el-input>
                    </el-form-item>
                    <el-form-item  label="汇率：" prop="foreign_exchange_rate">
                        <el-input v-model="editForm.foreign_exchange_rate" :disabled="editStockLimit"></el-input>
                    </el-form-item>
                    <el-form-item  label="仓库：" prop="warehouse_id">
                        <el-select v-model="editForm.warehouse_id" @visible-change="getSelectList('warehouse')" @change="inStockWarehouse($event,true)">
                            <el-option v-for="list in selectMap.warehouse" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="捆包号：" prop="bale_no">
                        <el-input v-model="editForm.bale_no" :disabled="editStockLimit"></el-input>
                    </el-form-item>
                    <el-form-item  label="库位：" prop="storage_location">
                        <!-- <el-input v-model="editForm.storage_location" v-if="this.editType==3"></el-input>
                        <el-select v-model="editForm.storage_location" v-else>
                            <el-option v-for="list in locationList" :key="list.id" :value="list.name" :label="list.name"></el-option>
                        </el-select> -->
                        <el-autocomplete
                            v-model="editForm.storage_location"
                            :fetch-suggestions="querySearch"
                            placeholder="请输入内容"
                            >

                        </el-autocomplete>
                    </el-form-item>
                    <el-form-item  label="合同号：" prop="contract_no">
                        <el-input v-model="editForm.contract_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="目的港：" prop="port_id">
                        <el-select v-model="editForm.port_id" @visible-change="getSelectList('port')">
                            <el-option v-for="list in selectMap.port" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="提单号：" prop="bill_lading_no">
                        <el-input v-model="editForm.bill_lading_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="编码：">
                        <el-input v-model="editForm.code"></el-input>
                    </el-form-item>
                    <el-form-item  label="货柜号：" prop="container_no">
                        <el-input v-model="editForm.container_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="属性：" prop="attribute_id">
                        <el-select v-model="editForm.attribute_id" clearable  @visible-change="getSelectList('attribute')">
                            <el-option v-for="list in selectMap.attribute" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="选色：" prop="color_id"  v-if="boardAmericaType">
                        <el-select v-model="editForm.color_id" clearable @visible-change="getSelectList('color')">
                            <el-option v-for="list in selectMap.color" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="货权单位：" prop="opening_company_id">
                        <el-select v-model="editForm.opening_company_id" clearable  @visible-change="getSelectList('opencompany')">
                            <el-option v-for="list in selectMap.opencompany" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="供单号：">
                        <el-input v-model="editForm.original_bale"></el-input>
                    </el-form-item>
                    <el-form-item  label="赎单日：" prop="redemption_day">
                        <el-input v-model="editForm.redemption_day"></el-input>
                    </el-form-item>
                    <el-form-item  label="到期日：" prop="expiry_time">
                        <el-input v-model="editForm.expiry_time"></el-input>
                    </el-form-item>
                    <el-form-item  label="产地：" prop="place_origin">
                        <el-input v-model="editForm.place_origin"></el-input>
                    </el-form-item>
                    <el-form-item  label="检尺：" prop="check_status">
                        <el-select v-model="editForm.check_status">
                            <el-option :value="0" label="未检尺"></el-option>
                            <el-option :value="1" label="已检尺"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="层数：" v-if="boardAfricaType">
                        <el-input v-model="editForm.layer_number" :disabled="mixedBag"></el-input>
                    </el-form-item>
                    <!-- <el-form-item  label="销售单价：" prop="sales_price">
                        <el-input v-model="editForm.sales_price"></el-input>
                    </el-form-item> -->
                    <!-- <el-form-item  label="采购成本单价：" prop="purchase_amount">
                        <el-input v-model="editForm.purchase_amount"></el-input>
                    </el-form-item> -->
                    <el-form-item  label="备注：" prop="remark">
                        <el-input v-model="editForm.remark"></el-input>
                    </el-form-item>
                    <el-form-item  label="备注1：" prop="remark_1">
                        <el-input v-model="editForm.remark_1"></el-input>
                    </el-form-item>
                    <el-form-item  label="销售品名：" prop="sales_breed_id" v-if="boardAfricaType">
                        <el-select v-model="editForm.sales_breed_id" @visible-change="getSelectList('saleBreed')" :disabled="editStockLimit">
                            <el-option v-for="list in selectMap.saleBreed" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="edit([editForm.id])">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="dialogVisible=!dialogVisible">取消</el-button>
            </div>
        </el-dialog>
        <!-- 修改库存END -->
        <!-- 修改百分比START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisiblePer" class="eldialog eldialogOneLabel" width="400px" :modal="false" title="修改百分比" custom-class="full_dialog">
            <div class="batchCube" slot="title">
                <span class="setIconLeft setIcon" v-if="module.includes(',setting-advanced-config-edit,')" @click="()=>decimalShow = true" title="设置小数点位数"><i class="el-icon-s-tools"></i></span>
                <span class="stock_cont_span">修改百分比</span>
            </div>
            <div class="">
                <el-form >
                    <el-form-item label="修改立方百分比:">
                        <el-input class="edit_input" v-model="perData.cube" placeholder=""></el-input>
                    </el-form-item>
                    <div style="font-size:12px;color:#777;margin-bottom:20px;float:left;width:100%;text-align:left;">注:值为0时，恢复为原码单方数,有检尺则先恢复为检尺立方</div>
                </el-form>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="PerEdit">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="dialogVisiblePer = false">取消</el-button>
            </div>
        </el-dialog>
        <!-- 修改百分比END -->
        <!-- 修改赎单日START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleHoverClick" class="eldialog eldialogOneLabel" width="290px" :modal="false" :title="hoverClickObj.title" custom-class="full_dialog">
            <div class="clearfix">
                <el-form >
                    <el-form-item :label="hoverClickObj.title+':'">
                        <el-input class="edit_input" v-model="hoverClickObj.val" placeholder=""></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="hoverClickConfirm">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="dialogVisibleHoverClick = false">取消</el-button>
            </div>
        </el-dialog>
        <!-- 修改赎单日END -->
        <!-- 检尺START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleChi" class="eldialog eldialogOneLabel" width="290px" :modal="false" title="检尺" custom-class="full_dialog">
            <div class="clearfix">
                <el-form >
                    <el-form-item label="捆包号:">
                        <el-input class="edit_input" @blur="chiBlur" v-model="chiData.bale_no" placeholder=""></el-input>
                    </el-form-item>
                        <el-form-item label="码单立方:">
                        <el-input class="edit_input" readonly v-model="chiData.original_cube" placeholder=""></el-input>
                    </el-form-item>
                        <el-form-item label="检尺立方:">
                        <el-input class="edit_input" id="chiCheckCube" v-model="chiData.check_cube" @input="chiCheckCube" placeholder=""></el-input>
                    </el-form-item>
                        <el-form-item label="销售立方:">
                        <el-input class="edit_input" v-model="chiData.sales_cube" :disabled="isCategoryEdit" placeholder=""></el-input>
                    </el-form-item>
                    <span v-if="isCategoryEdit">请点开销售总宽度修改销售立方</span>
                </el-form>
            </div>
            <div class="dialogBtnList clearfix" v-if="lock_status==1">
                    <el-button  style="width:110px;" class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="openTip(1)">保存并继续(Enter)</el-button>
                    <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="openTip(0)">保存</el-button>
                    <!-- <el-button class="funcPublicBtn dialogBtn" @click="dialogVisibleChi = false">关闭</el-button> -->
                </div>
                <div class="dialogBtnList clearfix" v-else>
                    <el-button style="width:110px;" class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="chiEdit('reset')">保存并继续(Enter)</el-button>
                    <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="chiEdit">保存</el-button>
                    <!-- <el-button class="funcPublicBtn dialogBtn" @click="dialogVisibleChi = false">关闭</el-button> -->
                </div>
        </el-dialog>
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleTip" class="eldialog eldialogOneLabel" width="290px" :modal="false" title="提示" custom-class="full_dialog">
                <div class="" style="">
                    资源被锁定，您检尺的同时会同步修改销售单内锁定在途货物的销售立方和挂牌价格，是否确定检尺！
                </div>
                <div class="dialogBtnList clearfix">
                    <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" v-if="tipType==1" @click="chiEdit('reset')">确定</el-button>
                    <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" v-else-if="tipType==0" @click="chiEdit">确定</el-button>
                    <!-- <el-button class="funcPublicBtn dialogBtn" @click="dialogVisibleChi = false">关闭</el-button> -->
                </div>
            </el-dialog>
        <!-- 检尺END -->
        <!-- 宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="isCanWidthEdit" :isHidePer="isHidePer" :ispost="ispost" :issetper="issetper" :widthSaleInventoryId="widthSaleInventoryId" :dialogvisible="dialogVisibleWidth" :type="widthObj.widthType" :widthid="widthObj.id" :list="widthObj.widthList" @changeSuccess="getList" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
         <!-- 销售宽度列表START -->
         <el-dialog v-dialog-drag :visible.sync="saleDialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="isSaleCanEditTotalWidth" :dialogvisible="saleDialogVisibleWidth" :list="widthObj.widthList" @returnwidth="res=>{saleWidthReturn(res)}" :type="1"  @cancelWidth="()=>{this.saleDialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 销售宽度列表END -->
        <!--execl START-->
        <el-dialog v-dialog-drag title="期初导入" :visible.sync="importDialogVisible" class="eldialog eldialogExcel" :modal="false" width='400px'>
            <div class="importExecl clearfix">
                <el-button v-if="boardAmericaType" :class="['funcPublicBtn',downLoadExeclType=='init_america_stock'?'funcPublicBtnChecked':'']" @click="downLoadExeclType='init_america_stock'">板材</el-button>
                <el-button v-if="boardAfricaType" :class="['funcPublicBtn',downLoadExeclType=='init_africa_stock'?'funcPublicBtnChecked':'']" @click="downLoadExeclType='init_africa_stock'">非洲材</el-button>
                <el-button v-if="nationalStandardType" :class="['funcPublicBtn',downLoadExeclType=='init_ds_stock'?'funcPublicBtnChecked':'']" @click="downLoadExeclType='init_ds_stock'">国标/非洲材</el-button>
            </div>
            <div class="text-center"  style="margin-top:20px;">
                <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload" accept=".xls,.xlsx">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text"  style="font-size:12px; color:#333;">将文件拖到此处，或<em style="color: #b21111;">点击上传</em></div>
                    <div class="el-upload__tip" slot="tip"  style="color: #888;margin-top:5px;">只能上传Excel文件</div>
                </el-upload>
                <div class="">
                    <el-link type="primary" @click='downTemplete' style="color:#b21111;font-weight:bold; cursor:pointer;">下载模板</el-link>
                </div>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="importFile">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="importDialogVisible=!importDialogVisible">取消</el-button>
            </div>
        </el-dialog>
        <!--execl END-->
        <!-- 组装拆卸记录 dialog START -->
        <el-dialog v-dialog-drag :visible.sync="zuDialogVisible" class="eldialog eldialogC eldialogBack eldialogTransfer eldialogWidth" :modal="false" :title="'组装拆卸记录'+'('+form_params.ad_no+')'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <div class="outAndInTitle">待出库</div>
                            <el-table :data="form_params.out.detail" border stripe show-summary highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="捆包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="属性" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',attribute,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.attribute }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="选色" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',color,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.color }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="厚度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_thickness,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.original_thickness }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="长度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_length,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.original_length }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="总宽度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_width_total,')!=-1">
                                    <template slot-scope="scope">
                                        <span @click="widthObj.widthList = JSON.parse(JSON.stringify(scope.row.width));dialogVisibleWidth=true;isCanEditTotalWidth=false;widthObj.widthType=''" style="text-decoration:underline;cursor:pointer;">
                                            {{ scope.row.original_width_total }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.layer_number }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="码单立方" prop="original_cube" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_cube,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.original_cube }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="采购单价" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',cube_price,')!=-1&&module.indexOf(',warehouse-combind-cost,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.cube_price }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="成本平摊单价" width="95" show-overflow-tooltip v-if="billColumn.indexOf(',cost,')!=-1&&module.indexOf(',warehouse-combind-cost,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.cost }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="挂牌价" width="95" show-overflow-tooltip v-if="billColumn.indexOf(',sales_price,')!=-1&&module.indexOf(',warehouse-combind-cost,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_price }}
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column label="船名" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.ship_no }}
                                    </template>
                                </el-table-column> -->
                                <el-table-column label="销售总宽" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_total_width,')!=-1">
                                    <template slot-scope="scope">
                                        <span @click="widthList = scope.row.sales_width;saleDialogVisibleWidth=true;isSaleCanEditTotalWidth=false;" style="text-decoration:underline;cursor:pointer;">
                                            {{ scope.row.sales_width_total }}
                                        </span>
                                        <!-- {{ scope.row.original_width_total }} -->
                                    </template>
                                </el-table-column>
                                <el-table-column label="销售立方" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_cube,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_cube }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="仓库" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',warehouse,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.warehouse }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="单片均宽" width="95" show-overflow-tooltip v-if="billColumn.indexOf(',avg_width,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.avg_width }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="榉木总宽" width="95" show-overflow-tooltip v-if="billColumn.indexOf(',zel_total_width,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.zel_total_width }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="重量" width="95" show-overflow-tooltip v-if="billColumn.indexOf(',zel_total_width,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.zel_total_width }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="宽度" width="95" show-overflow-tooltip v-if="billColumn.indexOf(',one_width,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.one_width }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="备注" width="103" show-overflow-tooltip v-if="billColumn.indexOf(',remark,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.remark }}
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="outAndInTitle">待入库</div>
                            <el-table :data="form_params.in.detail" border stripe show-summary highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="捆包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="属性" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',attribute,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.attribute }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="选色" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',color,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.color }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="厚度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_thickness,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.original_thickness }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="长度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_length,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.original_length }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="总宽度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_width_total,')!=-1">
                                    <template slot-scope="scope">
                                        <span @click="widthObj.widthList = JSON.parse(JSON.stringify(scope.row.width));dialogVisibleWidth=true;isCanEditTotalWidth=false;widthObj.widthType=''" style="text-decoration:underline;cursor:pointer;">
                                            {{ scope.row.original_width_total }}
                                        </span>
                                        <!-- {{ scope.row.original_width_total }} -->
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.layer_number }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="码单立方" prop="original_cube" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_cube,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.original_cube }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="采购单价" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',cube_price,')!=-1&&module.indexOf(',warehouse-combind-cost,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.cube_price }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="成本平摊单价" width="95" show-overflow-tooltip v-if="billColumn.indexOf(',cost,')!=-1&&module.indexOf(',warehouse-combind-cost,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.cost }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="挂牌价" width="95" show-overflow-tooltip v-if="billColumn.indexOf(',sales_price,')!=-1&&module.indexOf(',warehouse-combind-cost,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_price }}
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column label="船名" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.ship_no }}
                                    </template>
                                </el-table-column> -->
                                <el-table-column label="销售总宽" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_total_width,')!=-1">
                                    <template slot-scope="scope">
                                        <span @click="widthList = scope.row.sales_width;saleDialogVisibleWidth=true;isSaleCanEditTotalWidth=false;" style="text-decoration:underline;cursor:pointer;">
                                            {{ scope.row.sales_width_total }}
                                        </span>
                                        <!-- {{ scope.row.original_width_total }} -->
                                    </template>
                                </el-table-column>
                                <el-table-column label="销售立方" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_cube,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_cube }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="仓库" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',warehouse,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.warehouse }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="单片均宽" width="95" show-overflow-tooltip v-if="billColumn.indexOf(',avg_width,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.avg_width }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="榉木总宽" width="95" show-overflow-tooltip v-if="billColumn.indexOf(',zel_total_width,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.zel_total_width }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="重量" width="95" show-overflow-tooltip v-if="billColumn.indexOf(',zel_total_width,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.zel_total_width }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="宽度" width="95" show-overflow-tooltip v-if="billColumn.indexOf(',one_width,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.one_width }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="备注" width="103" show-overflow-tooltip v-if="billColumn.indexOf(',remark,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.remark }}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="remarkBox">
                        <textarea class="remarkTextarea" v-model="form_params.remark" cols="5" :readonly="true"></textarea>
                    </div>
                </div>
            </div>
            <div class="flex">
                <div>单据日期：{{form_params.order_time}}</div>
                <div>制单人：{{form_params.creator_name}}</div>
            </div>
        </el-dialog>
        <!-- 组装拆卸记录 dialog END -->
        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisiblesTransfer" class="eldialog eldialogC eldialogBack eldialogTransfer eldialogWidth" :modal="false" :title="'记录'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <div class="outAndInTitle dialogForm" style="padding-bottom: 7px;">
                                待转出库存明细
                                <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisible=!filterDialogVisible;scene = 'move.storage.out';isGlobal = true;"></div>
                            </div>
                            <el-table :data="form_params.out.detail" border stripe show-summary highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="操作"  width="80" v-if="isCanEdit">
                                    <template slot-scope="scope">
                                        <div class="icon_wrap">
                                            <i class="operation_add" @click="dialogVisibleStock=!dialogVisibleStock" title="添加"></i>
                                            <i class="operation_delete" @click="listDetailDelete(scope.$index)" title="删除"></i>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="转出仓库" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',warehouse,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.warehouse }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="库位" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',warehouse_local,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.warehouse_local }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品牌" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',brand,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.brand }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="规格" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',spec,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.spec }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.layer_number }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="方数" prop="cube" width="94" show-overflow-tooltip v-if="billColumn.indexOf(',cube,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.cube }}
                                        </span>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="transferType" >
                                <!-- <el-button :class="['transferBtn','funcPublicBtn',transferType==1?'funcPublicBtnChecked':'']" @click="handle(1)">组装</el-button>
                                <el-button :class="['transferBtn','funcPublicBtn',transferType==2?'funcPublicBtnChecked':'']" @click="handle(2)">拆卸</el-button> -->
                                <!-- <input placeholder="输入拆卸的包数" type="number" class="transferNumberInput" @input="inputTransferNumber" v-model="transferNumber" v-if="transferType==2"/> -->
                            </div>
                            <div class="ceshi1" style="display: flex;">
                                <div class="outAndInTitle">待转入库存明细</div>
                                <div class="editBtn">
                                    <el-button class="funcPublicBtn funcPublicBtnChecked" style="line-height: 27px;margin-bottom: 5px;" v-if="isCanEdit" @click="choose">选择仓库</el-button>
                                    <el-button class="fun" style="line-height: 27px;margin-bottom: 5px;" @click="openbusinessRelation"  v-if="isCanEdit">关联转库费用</el-button>
                                     <div v-if="fee_list.length>0" class="clearfix" style="float:left;margin-bottom: 5px;">
                                        <div class="newFee" v-for="(list,index) in fee_list" :key="'_'+index">
                                            {{list.fee_name+':  ￥'+list.amount}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <el-table :data="form_params.in.detail" border stripe show-summary highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="转库状态" width="80" show-overflow-tooltip>
                                    <template>
                                        {{ status }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="转入仓库" width="110" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.warehouse }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品牌" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',brand,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.brand }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="规格" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',spec,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.spec }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.layer_number }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="方数" prop="cube" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',cube,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.cube }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="费用平摊" width="94" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <!-- <el-input v-model="scope.row.remark" :readonly="isCanEdit"></el-input> -->
                                        <span>{{ scope.row.cost}}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="remarkBox">
                        <textarea class="remarkTextarea" v-model="form_params.remark" cols="5" :readonly="!isCanEdit"></textarea>
                    </div>
                </div>
                    <span class="bottom" v-if="bottom.creator_name">制单人:{{bottom.creator_name}}</span> 
                    <span class="bottom" v-if="bottom.out_time">转出时间:{{bottom.out_time}}</span>
                    <span class="bottom" v-if="bottom.transfer_name">入库人:{{bottom.transfer_name}}</span>
                    <span class="bottom" v-if="bottom.inbound_time">入库时间:{{bottom.inbound_time}}</span>
                <div class="editBtnList clearfix">
                    <div class="editBtn">
                
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->

        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="tiltingDialogVisibles" class="eldialog eldialogC eldialogBack eldialogTransfer eldialogWidth" :modal="false" :title="'货物翻包（加工）'+bottom.order_sn" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <div class="outAndInTitle dialogForm" style="padding-bottom: 7px;">
                                待翻包明细
                                <div class="globalFilterBtn"  @click="filterDialogVisible=!filterDialogVisible;scene = 'translate.package.out';isGlobal = true;"></div>
                            </div>
                            <el-table :data="form_params.out.detail" border stripe show-summary highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="操作"  width="80" v-if="isCanEdit">
                                    <template slot-scope="scope">
                                        <div class="icon_wrap">
                                            <i class="operation_add" @click="dialogVisibleStock=!dialogVisibleStock" title="添加"></i>
                                            <i class="operation_delete" @click="listDetailDelete(scope.$index)" title="删除"></i>
                                        </div>
                                    </template>
                                </el-table-column>
                                 <el-table-column label="包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品牌" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',brand,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.brand }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="厚度" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',thickness,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.original_thickness }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="长度" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',length,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.original_length }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="码单总宽度" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',original_width_total,')!=-1">
                                    <template slot-scope="scope">
                                        <span @click="widthObj.widthList = JSON.parse(JSON.stringify(scope.row.width));dialogVisibleWidth=true;isCanEditTotalWidth=false;widthObj.widthType=''" style="text-decoration:underline;cursor:pointer;">
                                        {{ scope.row.original_width_total }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.layer_number }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="码单立方" prop="cube" width="94" show-overflow-tooltip v-if="billColumn.indexOf(',original_cube,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.original_cube }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="成本单价"  width="94" show-overflow-tooltip v-if="billColumn.indexOf(',cost_price,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.cost_price }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="挂牌价"  width="94" show-overflow-tooltip v-if="billColumn.indexOf(',sales_price,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.sales_price }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="选色" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',color,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.color }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="属性" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',attribute,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.attribute }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="仓库"  width="94" show-overflow-tooltip v-if="billColumn.indexOf(',warehouse,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.warehouse }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="备注"  width="94" show-overflow-tooltip v-if="billColumn.indexOf(',remark,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.remark }}
                                        </span>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="transferType" >
                            </div>
                            <div class="ceshi1" style="display: flex;">
                                <div class="outAndInTitle">
                                    <span class="within">翻包 (加工) 结果录入</span>
                                </div>
                                <div class="editBtn">
                                    <el-button class="fun" style="line-height: 27px;margin-bottom: 5px;" @click="openData">成品明细</el-button>
                                    <el-button class="fun" style="line-height: 27px;margin-bottom: 5px;" @click="openbusinessRelation"  v-if="isCanEdit">关联转库费用</el-button>
                                     <div v-if="fee_list.length>0" class="clearfix" style="float:left;margin-bottom: 5px;">
                                        <div class="newFee" v-for="(list,index) in fee_list" :key="'_'+index">
                                            {{list.fee_name+':  ￥'+list.amount}}
                                        </div>
                                    </div>
                                </div>
                                <div class="globalFilterBtnes "  @click="filterDialogVisible=!filterDialogVisible;scene = 'translate.package.in';isGlobal = true;"></div>
                            </div>
                            <el-table :data="inventory_sum" border stripe highlight-current-row size="mini" height="100%">
                                <el-table-column prop="number" label="件数" width="120"></el-table-column>
                                <el-table-column prop="original_cube" label="码单立方" width="120"></el-table-column>
                                <el-table-column prop="purchase_amount" label="采购金额" width="120"></el-table-column>
                                <el-table-column prop="fee_amount" label="费用金额" width="120"></el-table-column>
                                <el-table-column prop="storage_number" label="已入库" width="120"></el-table-column>
                                <el-table-column prop="transit_number" label="待入库" width="120"></el-table-column>
                            </el-table>
                            <!-- <el-table :data="form_params.in.detail" border stripe show-summary highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品牌" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',brand,')!=-1">
                                    <template slot-scope="scope">
                                        {{scope.row.brand}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="厚度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',thickness,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.original_thickness }}
                                    </template>
                                </el-table-column>
                                 <el-table-column label="长度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',length,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.original_length }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="码单总宽度" width="100" show-overflow-tooltip v-if="billColumn.indexOf(',original_width_total,')!=-1">
                                    <template slot-scope="scope">
                                        <span @click="widthObj.widthList = JSON.parse(JSON.stringify(scope.row.width));dialogVisibleWidth=true;isCanEditTotalWidth=false;widthObj.widthType=''" style="text-decoration:underline;cursor:pointer;">
                                            {{scope.row.original_width_total}}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="销售总宽度" width="100" show-overflow-tooltip v-if="billColumn.indexOf(',sales_width_total,')!=-1">
                                    <template slot-scope="scope">
                                        <span @click="widthObj.widthList = JSON.parse(JSON.stringify(scope.row.width));dialogVisibleWidth=true;isCanEditTotalWidth=false;widthObj.widthType=''" style="text-decoration:underline;cursor:pointer;">
                                            {{scope.row.sales_width_total}}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                       {{scope.row.pieces}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                    <template slot-scope="scope">
                                        {{scope.row.layer_number}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="码单立方" prop="original_cube" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_cube,')!=-1">
                                    <template slot-scope="scope">
                                        {{scope.row.original_cube}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="销售立方" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_cube,')!=-1&&module.indexOf(',warehouse-combind-cost,')!=-1">
                                    <template slot-scope="scope">
                                        {{scope.row.sales_cube}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="平均成本单价" width="95" v-if="billColumn.indexOf(',cost,')!=-1&&module.indexOf(',warehouse-combind-cost,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.cost }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="挂牌价" width="95" v-if="billColumn.indexOf(',sales_price,')!=-1&&module.indexOf(',warehouse-combind-cost,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_price }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="选色" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',color,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.color }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="属性" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',attribute,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.attribute }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="仓库" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',warehouse,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.warehouse }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="备注" width="103" show-overflow-tooltip v-if="billColumn.indexOf(',remark,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.remark }}
                                    </template>
                                </el-table-column>
                            </el-table> -->
                        </div>
                    </div>
                    <div class="remarkBox">
                        <textarea class="remarkTextarea" v-model="form_params.remark" cols="5" :readonly="!isCanEdit"></textarea>
                    </div>
                </div>
                    <span class="bottom" v-if="bottom.creator_name">制单人:{{bottom.creator_name}}</span> 
                    <span class="bottom" v-if="bottom.tran_date">转出时间:{{bottom.tran_date}}</span>
                    <span class="bottom" v-if="bottom.transfer_name">入库人:{{bottom.transfer_name}}</span>
                    <span class="bottom" v-if="bottom.inbound_time">入库时间:{{bottom.inbound_time}}</span>
                <div class="editBtnList clearfix">
                    <div class="editBtn">
                        
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->

        <!-- 退货记录dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleRecord" class="eldialog eldialogC threeLabel eldialogBack eldialogWidth" :modal="false" :title="'退货单记录'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <div class="editPersonBox editPersonBoxTop clearfix">
                    <div class="editPerson">客户：{{form_params_record.customer_name}}</div>
                    <div class="editPerson">退货单号：{{form_params_record.order_return_sn}}</div>
                    <!-- <div class="editPerson">打印时间：{{parseInt(new Date().getTime()/1000) | dateFormat_}}</div> -->
                </div>
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <el-table :data="form_params_record.details" border stripe show-summary highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="捆包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                        <div class="sign" v-if="scope.row.new_inventory_id==new_inventory_id"></div>
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column label="供应商" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.supplier }}
                                    </template>
                                </el-table-column> -->
                                <el-table-column label="品牌" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',brand,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.brand }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="厚度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_thickness,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_thickness }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="长度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_length,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_length }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="总宽度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_width_total,')!=-1">
                                    <template slot-scope="scope">
                                        <span @click="widthObj.widthList = JSON.parse(JSON.stringify(scope.row.sales_width));dialogVisibleWidth=true;isCanEditTotalWidth=false;widthObj.widthType=''" style="text-decoration:underline;cursor:pointer;">
                                            {{ scope.row.sales_width_total }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.layer_number }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="销售立方" prop="sales_cube" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_cube,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.sales_cube }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="出库立方" prop="out_cube" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',out_cube,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.out_cube }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="退货片数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',return_pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.return_pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="退货立方" prop="return_cube" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',return_cube,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.return_cube }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="销售单价" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_price,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.sales_price }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="退款金额(￥)" prop="return_amount" width="103" show-overflow-tooltip v-if="billColumn.indexOf(',return_amount,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.return_amount }}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="remarkBox remarkBoxT remarkBoxFourText">
                        <textarea class="remarkTextarea" readonly v-model="form_params_record.remark" cols="5"></textarea>
                    </div>
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson">制单人：{{form_params_record.creator_name}}</div>
                    <div class="editPerson">销售人：{{form_params_record.salesman_name}}</div>
                    <div class="editPerson">退货时间：{{form_params_record.create_time | dateFormat_}}</div>
                </div>
            </div>
        </el-dialog>
        <!-- 退货记录dialog END -->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="inventory.statistic" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->

        <!-- 图片上传 START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleImg" class="eldialog eldialogOneLabel accountDialog" width="500px" :modal="false" title="图片上传" custom-class="full_dialog">
            <div class="upimgOutBox clearfix">
                <div class="upImgBox" v-for="(item,index) in upImagesList" :key="index+'_index'">
                    <img src="/icon/top-delete-suspension.png" class="upImgRemove" @click="upImgRemove(item)"/>
                    <img :src="item" class="upImg"/>
                </div>
                <el-upload class="upload-demo" ref='upload_path' drag multiple :action="oss.host" :data="upload_data" :on-success="handleImagesSuccess" :before-upload="beforeUpload" accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG">
                    <img src="/icon/addProductImg.png" class="uploadImageAdd">
                </el-upload>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="saveImgs(0)">覆盖保存</el-button>
                <el-button  class="funcPublicBtn dialogBtn" @click="saveImgs(1)">继续上传</el-button>
                <el-button class="funcPublicBtn dialogBtn" @click="dialogVisibleImg = false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 图片上传 END -->
        <!-- 文件上传 START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleFile" class="eldialog eldialogOneLabel eldialogFileUpload" width="500px" :modal="false" title="文件上传" custom-class="full_dialog">
            <div class="upFileOutBox clearfix">
                <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload">
                    <img src="/icon/upfile.png" class="uploadFileAdd">
                    <div class="uploadTitle">点击文件上传</div>
                </el-upload>
                <div class="upFileBox clearfix" v-for="(item,index) in upFileList" :key="index+'_index'">
                    <div class="upFile">{{item.name}}</div>
                    <img src="/icon/top-delete-suspension.png" class="upFileRemove" @click="upFileRemove(item.url)"/>
                    <div class="upFileUnder"></div>
                    <div class="upFileTop"></div>
                    <div class="upFileLeft"></div>
                    <div class="upFileRight"></div>
                </div>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="saveFile">保存</el-button>
                <el-button class="funcPublicBtn dialogBtn" @click="dialogVisibleFile = false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 文件上传 END -->
        <!-- 销售单 START-->
        <sale-bill-base ref="saleBillBase" :dialog="dialogVisibleSale" @hide="dialogVisibleSale=false"
                        :dt="3" :source="'inventory'" :form-data="detailInfo" :scene="'order.create.column'">
            <div class="editBtnList clearfix">
                <div style="float:left;">
                    <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                        <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                            {{list.fee_name+':  ￥'+list.amount}}
                        </div>
                    </div>
                </div>
            </div>
        </sale-bill-base>
        <!-- 销售单 END -->
        <relativeFile :dialog="downLoadFileDialog" @closeDialog="()=>{this.downLoadFileDialog = false}" :files="downFilesList"></relativeFile>
        <!-- 码单管理 START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleOrigin" class="eldialog originalManage" width="1200px" :modal="false" title="码单管理" custom-class="full_dialog">
            <original-manage :stockid="originalId" @getList="()=>{this.getList();}"></original-manage>
        </el-dialog>
        <!-- 码单管理 END -->
        <!-- 成本费用明细 START -->
        <el-dialog v-dialog-drag :visible.sync="costLogDetailDialog" class="eldialog"
                width="525px" :modal="false" :title="'成本费用明细'" custom-class="full_dialog">
            <div class="tableBox" style="max-height: 200px">
            <tabletem :isShowIndex="true" :is-hide-checkout="false" :is-align-center="true"  :tablecol="costLogDetailTableCol" :tabledata="costLogDetailList">
            </tabletem>
            </div>
            <div class="costLogBottomBtn" style="padding: 30px 0 0;">
                <el-button type="primary" @click="costLogDetailDialog=false">我知道了</el-button>
            </div>
        </el-dialog>
        <!-- 成本费用明细 START -->
        <el-dialog v-dialog-drag :visible.sync="costWarehouseDialog" class="eldialog"
                width="525px" :modal="false" :title="'仓储费用明细'" custom-class="full_dialog">
            <div class="tableBox" style="max-height: 200px">
            <tabletem :isShowIndex="true" :is-hide-checkout="false" :is-align-center="true" :isHideColumn="false" :tablecol="costWarehouseTableCol" :tabledata="costWarehouseList">
            </tabletem>
            </div>
            <div class="costLogBottomBtn" style="padding: 30px 0 0;">
                <el-button type="primary" @click="costWarehouseDialog=false">我知道了</el-button>
            </div>
        </el-dialog>
        <!-- 仓储费用明细 START -->
        <el-dialog v-dialog-drag :visible.sync="storageDetailDialog" class="eldialog"
                width="525px" :modal="false" :title="'仓储费用明细'" custom-class="full_dialog">
            <div class="tableBox" style="max-height: 200px">
            <tabletem :isShowIndex="true" :is-hide-checkout="false" :is-align-center="true"  :tablecol="costLogDetailTableCol" :tabledata="costLogDetailList">
            </tabletem>
            </div>
            <div class="costLogBottomBtn" style="padding: 30px 0 0;">
                <el-button type="primary" @click="storageDetailDialog=false">我知道了</el-button>
            </div>
        </el-dialog>
        <!-- 融资成本明细 END -->
        <el-dialog v-dialog-drag :visible.sync="costLogDetailDialogB" class="eldialog specTable"
                width="490px" :modal="false" :title="'融资成本明细'" custom-class="full_dialog">
            <div class="tableBox" style="min-height: 250px;max-height: 400px">
                <tabletem :isShowIndex="true" :is-hide-checkout="false" :isHideColumn="false" :is-align-center="true"  :tablecol="costLogDetailTableColB" :tabledata="costLogDetailListB">
                </tabletem>
            </div>
            <div style="padding: 5px;font-size: 15px;text-align: left;">
                合计  平摊金额:{{costLogtotal.amount}}
            </div>
            <!-- <div class="costLogBottomBtn" style="padding: 10px 0 0;">
                <el-button type="primary" @click="costLogDetailDialogB=false">我知道了</el-button>
            </div> -->
        </el-dialog>
        <!--弹框确认-->
        <!-- 同步销售总宽度 START -->
        <el-dialog v-dialog-drag :visible.sync="salesEditDialog" class="eldialog eldialogOneLabel totalChangeWidth spec" width="450px" :modal="false" title="是否确定修改" custom-class="full_dialog">
            <div class="whole">
                <el-checkbox v-model="sync_width"
                         class="confirmCheckBox">是否将厚度、长度、厚度mm、长度m的修改同步到销售总宽
                </el-checkbox>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="synchronization">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="salesEditDialog = false">取消</el-button>
            </div>
        </el-dialog>
        <!-- 同步销售总宽度 END -->

        <!-- 设置小数点位数 -->
        <el-dialog  v-dialog-drag title="小数点设置" :visible.sync="decimalShow" :before-close="decimalCancel" width="350px" class="eldialog" :model="false" custom-class="full_dialog">
            <div style="padding: 20px 10px;">
                <el-slider class="decimalSlider" v-model="decimalNum" :step="1" :mix="0" :max="4" show-stops input-size="size" :marks="decimalMarks"></el-slider>
                <div class="decimalMarks">注：请拖动选择保留几位小数</div>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn"  @click="decimalSave">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="decimalCancel">取消</el-button>
            </div>
        </el-dialog>
        <!-- 码单打印修改 dialog START -->
        <el-dialog ref="deposit_params"  v-dialog-drag title="码单打印修改" :visible.sync="addPrintManageDialog" class="eldialog no_print eldialogLine printEldialog"  :modal="false" custom-class="full_dialog">
            <el-form ref="deposit_params"  :model="print_params" class="dialogFormB clearfix">
                <!-- :rules="addDialogRules"  -->
                <div class="eldialogFormBox">
                    <el-form-item label="品名：" >
                        <el-input v-model="print_params.breed" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="合同号：" >
                        <el-input v-model="print_params.contract_no" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="User：" prop="user">
                        <el-input v-model="print_params.user" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="Date：" prop="date">
                        <el-date-picker v-model="print_params.date" type="date" ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="Shipment：" prop="shipment">
                        <el-input v-model="print_params.shipment" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="Location：" prop="location">
                        <el-input v-model="print_params.location" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="Species：" prop="species">
                        <el-input v-model="print_params.species" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="print_params.remark"  type="textarea" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="addPrintManageDialog=!addPrintManageDialog">取消</el-button>
                <el-button  class="publicBtn dialogBtn" v-if="printType==0" @click="addPrintManage(0)" style="margin-right: 15px;">原码单打印</el-button>
                <el-button  class="publicBtn dialogBtn" v-if="printType==0" @click="addPrintManage(1)">新码单打印</el-button>
                <el-button  class="publicBtn dialogBtn" v-if="printType==1" @click="addPrintManage()">修改</el-button>
            </div>
        </el-dialog>
        <!-- 码单打印修改 dialog END -->
        <!-- 细码单打印 dialog START -->
        <el-dialog v-dialog-drag :visible.sync="weightNotepintDialog" class="eldialog"
                width="1200px" :modal="false" :title="'码单打印管理'" custom-class="full_dialog">
             <div class="search_box clearfix StockSearch">
                <div class="search_select search_inputBox" >
                    <el-date-picker v-model="pint_start_time" type="date" placeholder="开始日期" size="mini"></el-date-picker>
                    ~
                    <el-date-picker v-model="pint_end_time" type="date" placeholder="结束日期" size="mini"></el-date-picker>
                </div>
                <el-select class="search_select search_inputBox" v-model="pint_params.type" collapse-tags  placeholder="码单类型">
                    <el-option :value="0" label="原码单"></el-option>
                    <el-option :value="1" label="新码单"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="pint_params.breed" placeholder="品名" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-model="pint_params.contract_no" placeholder="合同号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-model="pint_params.location" placeholder="Location" size="mini"></el-input>
                <el-input class="search_input search_inputBox"  v-model="pint_params.remark" placeholder="备注" size="mini"></el-input>
                <div class="searchBtnList clearfix">
                    <!-- <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div> -->
                    <div class="reset fcolor" @click="pintReset">重置</div>
                    <el-button  class="publicBtn" @click="printManage(true)">查询</el-button>
                </div>
            </div>
            <div class="tableBox" style="max-height: 500px;height: 400px">
                <tabletem :isShowIndex="true" :is-hide-checkout="false" :is-align-center="true" @getRow="getPintRow"  :tablecol="pintDetailTableCol" :tabledata="pintDetailList"  @getTableDelete="getPintTableDelete"  @getTableEdit="getPintTableEdit">
                </tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="printLast_page" :currentpages.sync="pint_params.page" :all.sync="printTotal" :pagesizes.sync="pint_params.per_page" @getPage="getPrintPage"></pagination>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="weightNotepintDialog=!weightNotepintDialog">关闭</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="exportPrintExcelBill">导出</el-button>
                <el-button  class="publicBtn dialogBtn"  style="margin-right: 15px;" @click="printConfirm">码单打印</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="batchPintDel">批量删除</el-button>
            </div>
        </el-dialog>
        <!-- 细码单打印 dialog END>-->
        <!-- 采购退货单 START -->
        <el-dialog v-dialog-drag :visible.sync="dialogReturnVisible" class="eldialog eldialogC threeLabel no_print eldialogWidth" :modal="false" :title="purchaseTypeText" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB dialogForm" :model="return_form_params" ref="saleorderA">
                        <div class="elFormBox">
                            <el-form-item  label="供应商名称：">
                                <el-select  v-model="return_form_params.supplier_id" disabled  @visible-change="getSelectList('supplier',$event)">
                                    <el-option v-for="list in selectMap.supplier" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="elFormBox">
                            <el-form-item  label="退货人：" prop="salesman_id">
                                <el-select  v-model="return_form_params.returner_id" disabled  @visible-change="getSelectList('user',$event)">
                                    <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="elFormBox">
                            <el-form-item label="退货日期：">
                                <el-date-picker v-model="return_form_params.date" disabled type="date" placeholder="" size="mini"></el-date-picker>
                            </el-form-item>
                        </div>
                        <div class="elFormBox elDialogElFormBoxCheckbox" v-if="return_form_params.tax_rate>0" >
                            <el-form-item  label="REC：">
                                <el-checkbox :disabled="true" v-model="return_form_params.rec"></el-checkbox>
                                <el-input v-model="return_form_params.tax_rate"  :disabled="true"  @input="calculationTableTotal(),recDigit($event)" placeholder="税率%：" class="checkbox elDialogElFormBoxCheckboxREC"></el-input>
                            </el-form-item>
                        </div>
                </el-form>
                <div class="">
                    <div class="editBox">
                        <div class="inwardRoll">
                            <el-table :data="listDetail" ref="outBoundDetailTable" border stripe highlight-current-row size="mini" height="100%" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                               
                                <template v-for="(item) in filters">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.includes(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>0 ?item.width:80+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                        <template slot-scope="scope">
                                            <!-- <div v-if="item.field == 'sales_width_total'">
                                                <span @click="widthList = scope.row.sales_width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                                    {{ scope.row.sales_width_total }}
                                                </span>
                                            </div> -->
                                            <span >
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                        <div class="dialogTotal clearfix">
                        <div class="dialogTotalC">合计应退</div>
                            <div class="dialogTotalC" v-if="return_form_params.purchase_amount">退款金额:{{return_form_params.purchase_amount}}</div>
                        </div>
                    </div>
                    <div style="display: flex;">
                        <span class="redColor" style="padding-top: 7px;">*</span>
                    <div class="returnReason">
                        <textarea class="remarkTextarea" disabled :readonly="false" v-model="return_form_params.remark" cols="5"></textarea>
                    </div>
                    </div>
                    <div class="editLeft">
                        <textarea class="remarkTextarea" disabled :readonly="false" v-model="return_form_params.ship_no" cols="5"></textarea>
                    </div>
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson" v-if="return_form_params.creator_name">制单人：{{return_form_params.creator_name}}</div>
                    <!-- <div class="editPerson">审核人：{{return_form_params.auditor_name}}</div> -->
                    <!-- <div class="editPerson">打印时间：{{parseInt(new Date().getTime()/1000) | dateFormat_}}</div> -->
                </div>
                <div class="editBtnList clearfix">
                    <div style="float:left;margin-bottom: 10px;">
                        <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                            <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                                {{list.fee_name+':  ￥'+list.amount}}
                            </div>
                        </div>
                    </div>
                    <!-- <div style="float:left;">
                        <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                            <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                                {{list.fee_name+':  ￥'+list.amount}}
                            </div>
                        </div>
                    </div> -->
                    <div class="editBtn">
                        <el-button class="funcPublicBtn " @click="dialogReturnVisible=false">关闭</el-button>                         
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 采购退货单 END -->
        <!--REC START -->
        <el-dialog  v-dialog-drag title="税金修改" :visible.sync="recChanges"
                width="350px" class="eldialog no_print eldialogLine" :model="false" custom-class="full_dialog">
            <el-form :model="rec_params" :rules="recRules"  :inline="true" class="dialogFormB clearfixe"
                size="mini">
                <div class="eldialogFormBox">
                    <el-form-item label="REC：" >
                        <el-checkbox class="taxCheck" v-model="rec_params.rec" style="margin-right: 10px;"></el-checkbox>
                        <!-- <el-input  v-model="rec_params.tax_rate"  style="width:145px;" v-digits:4="rec_params.tax_rate" @input="change($event)" class="formInput tax_rate">
                        </el-input>
                        <span style="position: absolute;right: 5px;">%</span> -->
                    </el-form-item>
                    <el-form-item label="是否含票价：" v-if="rec_params.rec">
                        <el-select v-model="rec_params.with_ticket" placeholder="" >
                            <el-option :value="0"  label="否"></el-option>
                            <el-option :value="1"  label="是"></el-option>
                        </el-select>
                    </el-form-item> 
                    <el-form-item  label="税率："  v-if="rec_params.with_ticket==0&&rec_params.rec" class="dialogTwo clearfix" prop="tax_rate" >
                        <el-select class="twoSelect" v-model="rec_params.rec_type" placeholder="" >
                            <!-- @change="TaxesTableTotal()"  -->
                            <el-option :value="'MUL'"  label="×"></el-option>
                            <el-option :value="'DIV'"  label="÷"></el-option>
                        </el-select>
                        <!-- @input="exchangeRate" -->
                        <el-input class="twoInput"  v-model="rec_params.tax_rate"></el-input>
                        <!-- @input="TaxesTableTotal()" -->
                    </el-form-item>
                    <el-form-item label="税金：" v-if="rec_params.with_ticket==0&&rec_params.rec">
                        <el-input class="formInput" v-model="rec_params.amount" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="税金：" v-if="rec_params.with_ticket==1&&rec_params.rec">
                        <el-input class="formInput" v-model="rec_params.amount"></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <textarea style="min-height: 60px;" class="edit_input edit_textarea formInput" v-model="rec_params.remark">
                        </textarea>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix" style="text-align: right;margin-top: 30px;">
                <el-button class="dialogBtn funcPublicBtn" @click="recChanges = false">取消</el-button>
            </div>
        </el-dialog>
        <!--REC END -->
        <filter-fields :tableData="filter" :isGlobal="isGlobal" scene="purchase.return.create" :filterDialogVisible="filterDialogVisibleA" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisibleA = val;}"></filter-fields>

    </div>
</template>
<style scoped lang="scss">
    .originalManage ::v-deep .el-dialog__body{padding:0;}

    .templete ::v-deep .eldialogExcel .text-center{margin-top:10px!important;}
    .dialogBtnList {padding:10px 0;}
    .eldialog.eldialogOneLabel /deep/ .el-form-item .el-form-item__content{width:160px;}

    .upimgOutBox .uploadImageAdd{width:100%;height:100%;}
    .upimgOutBox .upload-demo{float: left;width:102px;height:102px;overflow: hidden;}
    .upimgOutBox .upImgBox{position: relative;width:102px;height:102px;float: left;margin-right:10px;margin-bottom:10px;position: relative;}
    .upimgOutBox .upImg{display: block;width:100%;height:100%;}
    .upimgOutBox .upImgRemove{width:20px;height:20px;position: absolute;top:5px;right:5px;cursor:pointer;}
    .upFileOutBox .upFileBox{width:100%;margin-bottom:10px;border-radius: 5px;box-shadow: 0 0 5px #ccc;padding:2px 10px;margin-top:10px;}
    .upFileOutBox .upFile{display: block;float: left;font-size: 14px;}
    .upFileOutBox .upFileRemove{width:15px;height:15px;float:right;cursor:pointer;margin-top:2px;}
    .upFileOutBox .uploadFileAdd{width:60px;height:50px;display: block;margin:auto;margin-top:10px;}
    .upFileOutBox .upload-demo{width:100%;height:100px;overflow: hidden;}
    .upFileOutBox .uploadTitle{width:100%;text-align: center;font-size: 14px;margin-top:5px;}

    .upFileBox:hover{transform: translateY(-2px);cursor: pointer;}
    .upFileUnder{width:0;height:0;transition: 0.3s ease-out;position: absolute;right:0;margin: auto;bottom:0;border-radius: 35px;}
    .upFileTop{width:0;height:0;transition: 0.3s ease-out;position: absolute;left:0;margin: auto;top:0;border-radius: 35px;}
    .upFileLeft{width:0;height:0;transition: 0.3s ease-out;position: absolute;left:0;margin: auto;bottom:0;border-radius: 35px;}
    .upFileRight{width:0;height:0;transition: 0.3s ease-out;position: absolute;right:0;margin: auto;top:0;border-radius: 35px;}
    .upFileBox:hover .upFileUnder{width:100%;height:0;border-top:1px solid #b21111;}
    .upFileBox:hover .upFileTop{width:100%;height:0;border-top:1px solid #b21111;}
    .upFileBox:hover .upFileLeft{width:0;height:100%;border-left:1px solid #b21111;}
    .upFileBox:hover .upFileRight{width:0;height:100%;border-left:1px solid #b21111;}


    .delWidth{width:10px;height:10px;position: absolute;top:0;right:0;background: url('../../assets/top-delete-suspension.png') no-repeat 100% 100%;background-size: 100% 100%;cursor: pointer;}
    .addWidth{position: relative; width:32px;height:32px;float:left;background: url('../../assets/addWidth.png') no-repeat 50% 50%;background-size: 70% 70%;cursor: pointer;}
    .importExecl{width:100%;text-align: center;}
    .importExecl .funcPublicBtn{display: inline;float: none;}
    .sign{width:15px;height:15px;background: url('/icon/lu.png') no-repeat 100% 100%;background-size: 100% 100%;float: right;position: relative;top:4px;}
    .eldialogBack.eldialogC .dialogFlow{    max-height: 560px;overflow: unset;}
    .eldialogBack .remarkBox{width:1090px;}
    .eldialogBack .remarkBoxT{width:1090px;}

    .bottom_flex{ display: flex; padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
    .remarkBoxFourText{padding:5px 5px 5px 60px;}
    .remarkBoxFourText:before{content:"退货原因:";}
    .bottom{padding-right: 20px;}
    .transferType{padding:10px 0;}
    .flex{display: flex;}
    .flex div{padding-right: 20px}
    .outAndInTitle{padding:10px 0;padding-right: 20px;padding-top: 5px;font-weight: 600;color: #333;}
    .within{border-left: 4px solid #b21111;padding-left: 6px;}
    .contractLabel:hover{cursor: pointer;color: #b21111;}
    .contractLabel:hover .labelTip{display: block;}
    .labelTip{display: none;
    position: absolute;font-weight: 600;top:-65px;left:-50px;z-index:1;width:180px;
    text-align: left;border-radius: 4px;padding:10px;box-sizing: border-box;
    box-shadow: 1px 1px 5px #ccc;padding-left:30px;z-index: 100;background-color: #000;opacity: 0.8;
    color: aliceblue;}
    .decimalMarks{color: #777;text-align:left;margin-top: 25px;font-size: 13px;}
    .decimalSlider /deep/ .el-slider__marks .el-slider__marks-text{width: 50px;font-size: 12px;}
    .decimalSlider /deep/ .el-slider__bar{background-color:#b21111;}
    .decimalSlider /deep/ .el-slider__button{border-color: #b21111;}
    .StockSearch .el-input{width:100px!important;}
    .form_edits{width:20px;position: absolute;left: 20px;}

</style>
<script>
    import tabletem from '../../components/table.vue';
    import pagination from '../../components/pagination.vue';
    import relativeFile from '../../components/downloadRelativeFile.vue';
    import originalManage from '../../components/warehouse/originalManage.vue';
    import saleBillBase from '../../components/saleBillBase';

    export default {
        data(){
            return{
                batchFlag:false,
                widthSaleInventoryId:"",
                dialogVisibleOrigin:false,
                originalId:"",
                tableLoading:false,
                downLoadFileDialog:false,
                downFilesList:[],
                dialogVisibleSale:false,
                dialogVisiblesTransfer:false,
                detailInfo: {},
                newFee: [],
                saleOrderId:"",
                module:localStorage.dw_erp_power_code,
                categoryRawType:localStorage.dw_erp_category.indexOf("raw")!=-1?true:false,
                categoryBoardType:localStorage.dw_erp_category.indexOf("board")!=-1?true:false,
                categoryScrapType:localStorage.dw_erp_category.indexOf("scrap")!=-1?true:false,
                categoryGlulamType:localStorage.dw_erp_category.indexOf("glulam")!=-1?true:false,
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                nationalStandardType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                isShowMore:false,
                importDialogVisible:false,
                dialogVisibleRecord:false,
                billColumn:"",
                ispost:true,
                isHidePer:false,
                issetper:false,
                start_time:"",
                end_time:"",
                start_out_time:"",
                end_out_time:"",
                //费用平摊单价
                costLogDetailDialog:false,
                costWarehouseDialog:false,//仓储费用明细
                costLogDetailDialogB:false,
                explainDialog:false,
                explainCostDialog:false,
                explainStockDialog:false,
                storageDetailDialog:false,//仓储费用明细
                costLogDetailList:[],
                costLogDetailListB:[],
                costWarehouseList:[],
                costLogDetailTableCol:[
                    {colName:"平摊日期",colKey:"fee_date",isDate:true,}, 
                    {colName:"费用名称",colKey:"fee_name"}, 
                    {colName:"平摊单价",colKey:"amount"}, 
                    {colName:"操作人",colKey:"creator_name"}, 
                ],
                costLogDetailTableColB:[
                    {colName:"平摊日期",colKey:"fee_date",isDate:true,},
                    {colName:"费用名称",colKey:"fee_name"},
                    {colName:"平摊单价",colKey:"amount"},
                    {colName:"操作人",colKey:"creator_name"},
                ],
                costWarehouseTableCol:[
                    // isDate:true,
                    {colName:"天数",colKey:"number",}, 
                    {colName:"仓库类型",colKey:"warehouse_type"}, 
                    {colName:"单价/天",colKey:"amount"}, 
                    {colName:"操作人",colKey:"creator_name"}, 
                ],
                pintDetailTableCol:[
                    {colName:"码单类型",colKey:"type_text"},
                    {colName:"品名",colKey:"breed"},
                    {colName:"合同号",colKey:"contract_no"},
                    {colName:"件数",colKey:"number"},
                    {colName:"Date",colKey:"date",isDate:true,},
                    {colName:"User",colKey:"user"},
                    {colName:"Shipment",colKey:"shipment"},
                    {colName:"Location",colKey:"location"},
                    {colName:"Species",colKey:"species"},
                    {colName:"操作时间",colKey:"create_time",isDate:true,},
                    {colName:"操作人",colKey:"creator_name"},
                    {colName:"备注",colKey:"remark"},
                ],
                pintDetailList:[],
                costLogtotal:{},
                params:{
                    start_time:"",
                    end_time:"",
                    supplier_id:"",
                    storage_age_start:"",
                    storage_age_end:"",
                    breed_id:"",
                    thickness:"",
                    length:"",
                    grade_id:"",
                    bale_no:"",
                    warehouse_id:"",
                    status:"",
                    bale_status:[1],
                    check_status:999,
                    category:"",
                    contract_no:"",
                    bill_lading_no:"",
                    place_origin:"",
                    container_no:"",
                    storage_location:"",
                    ship_no:"",
                    batch_no:"",
                    heap_no:"",
                    remark:"",
                    start_out_time:"",
                    end_out_time:"",
                    brand_id:"",
                    attribute_id:"",
                    color_id:"",
                    redemption_day:"",
                    expiry_time:"",
                    opening_company_id:"",
                    original_bale:"",
                    price_min:"",
                    price_max:"",
                    field:"",
                    sort:"",
                    is_like:false,
                    page:1,
                    per_page:50
                },
                last_page:1,
                printLast_page:1,
                total:0,
                printTotal:1,
                selectRow:[],
                categoryList:[],
                selectMapC:{
                    supplier_id:[],
                    breed_id:[],
                    brand_id:[],
                    port_id:[],
                    grade_id:[],
                    warehouse_id:[],
                    original_length:[],
                    original_thickness:[],
                    attribute_id:[],
                    color_id:[],
                    opening_company_id:[],
                    status:[],
                    bale_status:[],
                    place_origin:[]
                },
                selectMap:{
                    port:[],
                    warehouse:[],
                    supplier:[],
                    breed:[],
                    brand:[],
                    grade:[],
                    attribute:[],
                    color:[],
                    saleBreed:[],
                    currency:[],
                },
                locationList:[],
                form_params:{
                    out:{
                        detail:[
                            {
                                id:"",
                                bale_no:"",
                                brand_id:"",
                                brand:"",
                                breed:"",
                                breed_id:"",
                                grade_id:"",
                                grade:"",
                                original_thickness:"",
                                original_length:"",
                                original_width_total:"",
                                pieces:"",
                                original_cube:"",
                                sales_cube:"",
                                cube_price:"",
                                cost:"",
                                cost_price:"",
                                ship_no:"",
                                status:"",
                                warehouse:"",
                                warehouse_id:"",
                                remark:"",
                                status_text:""
                            }
                        ]
                    },
                    in:{
                        detail:[
                            {
                                id:"",
                                bale_no:"",
                                brand_id:"",
                                brand:"",
                                breed:"",
                                breed_id:"",
                                grade_id:"",
                                grade:"",
                                original_thickness:"",
                                original_length:"",
                                original_width_total:"",
                                pieces:"",
                                original_cube:"",
                                sales_cube:"",
                                cube_price:"",
                                cost:"",
                                cost_price:"",
                                ship_no:"",
                                status:"",
                                warehouse:"",
                                warehouse_id:"",
                                remark:"",
                                status_text:""
                            }
                        ]
                    },
                    remark:""
                },
                form_params_record:{},
                list:[],
                tableCol:[
                    // isDialogView:true,
                    {colName:"资源状态",colKey:"status_str",colWidth:90,isSetWidth:true,isDialogView:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"检尺状态",colKey:"check_status_text",colWidth:75,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售状态",colKey:"status_text",colWidth:75,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"入库日期",colKey:"inbound_time",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isSort:true,isColor:true},
                    {colName:"库龄",colKey:"storage_age",colWidth:60,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"捆包号",colKey:"bale_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"供单号",colKey:"original_bale",colWidth:65,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"销售品名",colKey:"sales_breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"产品图片",colKey:"thumbnail",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isStockImg:true,isColor:true},
                    {colName:"等级",colKey:"grade",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"厚度",colKey:"original_thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"长度",colKey:"original_length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"属性",colKey:"attribute",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"选色",colKey:"color",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"产地",colKey:"place_origin",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"编码",colKey:"code",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"外商单号",colKey:"ex_order_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"币种",colKey:"foreign_currency_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"码单长度",colKey:"original_length",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"层数",colKey:"layer_number",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"码单总宽度",colKey:"original_width_total",colWidth:85,isSetWidth:true,isCanClick:true,isShow:true,isHideShowClickImg:true,isHideCanClickColor:true,isColor:true},
                    {colName:"销售总宽度",colKey:"sales_width_total",colWidth:80,isSetWidth:true,isCanClick:true,isShow:true,isHideShowClickImg:true,isHideCanClickColor:true,isColor:true},
                    {colName:"码单立方",colKey:"original_cube",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"检尺立方",colKey:"check_cube",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"立方差",colKey:"cube_sub",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"方差%",colKey:"cube_pct",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售立方",colKey:"sales_cube",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"挂牌价",colKey:"sales_price",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"板尺",colKey:"plate_ruler",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"外币单价",colKey:"foreign_currency_price",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"采购单价",colKey:"cube_price",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"采购金额",colKey:"purchase_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"融资平摊单价",colKey:"finance_cost",colWidth:100,isSetWidth:true,isCanClick:true,isPopout:true,isHideShowClickImg:true,isColor:true},
                    {colName:"费用平摊单价",colKey:"cost",colWidth:100,isSetWidth:true,isCanClick:true,isPopout:true,isHideShowClickImg:true,isColor:true},
                    {colName:"仓储费单价",colKey:"warehouse_cost",colWidth:100,isSetWidth:true,isCanClick:true,isPopout:true,isHideShowClickImg:true,isColor:true},
                    {colName:"仓储费金额",colKey:"warehouse_amount",colWidth:100,isSetWidth:true,isCanClick:false,isColor:true},
                    {colName:"采购金额",colKey:"purchase_amount",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"成本单价",colKey:"cost_price",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"采购成本金额",colKey:"cost_amount",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"成本金额",colKey:"inventory_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"货权单位",colKey:"opening_company",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"赎单日",colKey:"redemption_day",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isHoverClick:true,isColor:true},
                    {colName:"到期日",colKey:"expiry_time",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"库位",colKey:"storage_location",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isHoverClick:true,isColor:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"货柜号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    // {colName:"库龄",colKey:"storage_age",colWidth:55,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"库存类型",colKey:"category",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isHoverClick:true,isColor:true},
                    {colName:"备注1",colKey:"remark_1",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isHoverClick:true,isColor:true},
                    {colName:"船名",colKey:"ship_no",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"批次号",colKey:"batch_no",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"堆号",colKey:"heap_no",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"挂牌金额",colKey:"listed_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"关联文件",colKey:"files",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isRelativeFile:true,isColor:true},
                    {colName:"出库日期",colKey:"out_time",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"实付汇率",colKey:"foreign_exchange_rate",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"转库日期",colKey:"move_in_time",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isSort:true,isColor:true},
                    {colName:"可用立方",colKey:"enable_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                perData:{
                    id:[],
                    cube:""
                },
                dialogVisible:false,
                dialogVisiblePer:false,
                dialogVisibleChi:false,
                dialogVisibleWidth:false,
                saleDialogVisibleWidth:false,//销售总宽弹框
                isSaleCanEditTotalWidth:false,
                zuDialogVisible:false,
                isCanWidthEdit:false,
                widthObj:{
                    id:"",
                    widthList:[],
                    widthType:2,//2.码单 3.销售
                },
                editForm:{
                    id:[],
                    inbound_time:"",
                    bale_no:"",
                    breed_id:"",
                    brand_id:"",
                    original_thickness:"",
                    original_length:"",
                    pieces:"",
                    original_cube:"",
                    sales_price:"",
                    cube_price:"",
                    foreign_exchange_rate:"",
                    purchase_amount:"",
                    foreign_currency_price:"",
                    warehouse_id:"",
                    supplier_id:"",
                    contract_no:"",
                    place_origin:"",
                    bill_lading_no:"",
                    port_id:"",
                    container_no:"",
                    remark:"",
                    layer_number:"",
                    redemption_day:"",
                    expiry_time:"",
                    original_bale:"",
                    remark_1:"",
                    code:"",
                    opening_company_id:"",
                    storage_location:"",
                    check_status:"",
                    sales_breed_id:""
                },
                chiData:{
                    id:"",
                    bale_no:"",
                    original_cube:"",
                    check_cube:"",
                    sales_cube:""
                },
                totalObj:{},
                perIds:[],
                perType:2,//修改百分比  2单个修改 3多个修改
                editIds:[],
                editType:2,//修改  2单个修改 3多个修改
                upload_data : {},
				oss : {
                    host : "",
                },
                file_url : '',
                isUpImg:0,
                dialogVisibleImg:false,
                upImgObj:{
                    kid:[],
                    images:[]
                },
                dialogVisibleFile:false,
                upFileObj:{
                    kid:[],
                    files:[]
                },
                upImagesList:[],
                upFileList:[],
                downLoadExeclType:"",
                filterDialogVisible:false,
                dialogVisibleHoverClick:false,
                redemptionEdit:{
                    id:"",
                    redemption_day:"",
                },
                filter:"",
                fields:"",
                new_inventory_id:"",
                selectCube:0.0000,
                hoverClickObj:{
                    id:"",
                    title:"",
                    val:"",
                    posturl:"",
                    key:""
                },
                continueId:"",
                continueFlag:true,
                editStock:false,
                editStockLimit:false,
                isCanEdit:false,
                fee_list:[],
                status:"",
                bottom:{
                    inbound_time:"",
                    creator_name:"",
                    transfer_name:"",
                    out_time:""
                },
                tiltingDialogVisibles:false,
                restaurants: [],
                allInfos:[],
                lock_status:999,
                dialogVisibleTip:false,
                tipType:999,
                is_like:false,
                inventory_sum:[],
                salesEditDialog:false,
                sync_width:false,
                editCategory:false,
                isCategory:0,
                isCategoryNumber:0,

                // 立方小数点
                decimalShow:false,
                decimalNum:Number(localStorage.getItem('dm_erp_decimal_scale')),
                decimalMarks:{
                    0:'0',
                    1:'0.1',
                    2:'0.01',
                    3:'0.001',
                    4:'0.0001',
                },
                originalGraying:false,//码单是否置灰
                mixedBag:false,//混包置灰
                isCategoryEdit:false,
                addPrintManageDialog:false,//码单管理
                print_params:{
                    breed:'',
                    contract_no:'',
                    date:'',
                    location:'',
                    shipment:'',
                    species:'',
                    user:'',
                    remark:'',
                },
                // addDialogRules:{
                //     date: [{ required: true, message: '不能为空', trigger: 'change' }],
                //     user: [{ required: true, message: '不能为空', trigger: 'change' }],
                //     shipment: [{ required: true, message: '不能为空', trigger: 'change' }],
                //     location: [{ required: true, message: '不能为空', trigger: 'change' }],
                //     species: [{ required: true, message: '不能为空', trigger: 'change' }],
                // },
                weightNotepintDialog:false,//码单打印弹框
                pint_params:{
                    start_time:"",
                    end_time:"",
                    type:"",
                    breed:"",
                    contract_no:"",
                    user:"",
                    shipment:"",
                    location:"",
                    species:"",
                    remark:"",
                    page:1,
                    per_page:50
                },
                selectPintRow:[],
                pint_start_time:'',
                pint_end_time:'',
                printType:'',
                originalInbound:'',//原始时间
                dialogReturnVisible:false,//采购退货单
                return_form_params:{
                    supplier_id:"",
                    returner_id: localStorage.dw_erp_user_id ? parseInt(localStorage.dw_erp_user_id) : "",
                    date:new Date(),
                    rec:0,
                    details:[],
                    fees:[],
                    ship_no:"",
                    remark:"",
                },
                purchaseTypeText:'',
                tableTotal:{
                    return_amount:0.00,
                    tax_amount:0.00,
                    refund_amount:0.00,
                },
                listDetail:[],
                filters:[],
                filterDialogVisibleA:false,//新建弹框列设置
                isGlobal:false,
                rec_params:{
                    rec:'',
                    rec_type:'MUL',
                    with_ticket:'',
                    tax_rate:'',
                    amount:'',
                    remark:'',
                },
                recChanges:false,
                f_rec:'',
                recRules:{
                    tax_rate: [{ required: true, message: '不能为空', trigger: 'change' }],
                },
            }
        },
        created(){
            this.getSelectList("brand")
            this.getSelectList("breed")
            this.getSelectList("port")
            this.getSelectList("grade")
            this.getSelectList("warehouse")
            this.getSelectList("supplier")
            this.getSelectList("attribute")
            this.getSelectList("color")
            this.getSelectList('opencompany');
            this.getSelectList('saleBreed');
            this.getSelectWarehouseList("attribute_id")
            this.getSelectWarehouseList("color_id")
            this.getSelectWarehouseList('bale_status')
            this.postFunc("/erp/purchase.category",{},res=>{
                this.categoryList=res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            })                                                              
                                                                            // this.nationalStandardType?"init_ds_stock":           
            this.downLoadExeclType=this.boardAmericaType?"init_america_stock":this.nationalStandardType?"init_ds_stock":this.nationalStandardType?"init_ds_stock":"";
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
            document.addEventListener("keyup",res=>{
                if(this.dialogVisibleChi){
                    if(res.keyCode == 13){
                        if(this.continueFlag){
                            this.chiEdit("reset",()=>{
                                let flag = false;
                                for(let i=0;i<this.list.length;i++){
                                    if(this.continueId == this.list[i].id){
                                        flag = true;
                                    }
                                    if(flag){
                                        if(this.list[i].check_status == 0 && this.list[i].status != 5){
                                            let arr = new Array();
                                            arr[0] = this.list[i].id;
                                            this.chiData.id=arr;
                                            this.chiData.bale_no = this.list[i].bale_no;
                                            this.chiData.original_cube = this.list[i].original_cube;
                                            this.chiData.check_cube = this.list[i].check_cube;
                                            this.chiData.sales_cube = this.list[i].sales_cube;
                                            this.chiBlur()
                                            break;
                                        }
                                    }
                                }
                            })
                        }
                    }
                }
            })
            this.editStock = localStorage.dw_erp_power_code.indexOf("warehouse-statistic-lock-edit")!=-1? true:false;
        },
        methods:{
            headDrog(newWidth, oldWidth, column) {
                this.filters.forEach((item) => {
                    if (column.property == item.colKey) {
                        item.colWidth = newWidth;
                    }
                });
                let obj = {};
                obj.width = parseInt(newWidth);
                obj.name = column.property;
                let emit = ("changeHeadWidth" + this.scene).replace(/\./g, "");
                bus.$emit(emit, obj);
            },
            // 立方小数点确认
            decimalSave(){
                let {decimalNum} = this.$data;
                this.postFunc("/erp/system.set.config",{key:"DECIMAL_CUBE_SCALE",value:decimalNum,status:1},res=>{
                    this.tip('设置成功',"success")
                    this.decimalShow = false;
                    // 设置缓存
                    localStorage.setItem('dm_erp_decimal_scale',decimalNum);

                    this.getList();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            decimalCancel(){
                this.decimalShow = false;
            },
            decimalGet(){
                this.postFunc("/erp/system.get.config",{key:"DECIMAL_CUBE_SCALE"},res=>{
                    this.decimalNum = res.data.data.value==''?4:Number(res.data.data.value);
                    // 设置缓存
                    localStorage.setItem('dm_erp_decimal_scale',this.decimalNum);
                },error=>{
                    
                })
            },
            inStockWarehouse(e,flag,func){
                this.postFunc("/erp/warehouse.location.select",{warehouse_id:e},res=>{
                    if(flag){
                        this.editForm.storage_location = "";
                    }
                    this.locationList = res.data.data;
                    this.allInfos= this.locationList.map((terminal) => {
                        return {
                            value: terminal.name,
                        };
                    });
                    if(func){
                        func()
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            querySearch(queryString, cb) {
                var restaurants = this.allInfos;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            // @select="handleSelect"
            // handleSelect(item) {
            //     console.log(item);
            // },
            //码单管理
            printManage(){
                this.pint_params.pint_start_time=this.formatTimeZero(this.pint_start_time);
                this.pint_params.pint_end_time=this.formatTimeZero(this.pint_end_time);
                this.postFunc('/erp/inventory.sheet.prints',this.pint_params,res=>{
                    this.printLast_page = parseInt(res.data.data.last_page);
                    this.printTotal=parseInt(res.data.data.total);
                    this.pintDetailList = res.data.data.data;
                    this.pintDetailList.forEach(item=>{
                        item.isEdit=true;
                        item.isDelete=true;
                    })
                })
                this.weightNotepintDialog = true;
            },
            //码单管理重置
            pintReset(){
                this.pint_start_time='';
                this.pint_end_time='';
                this.pint_params=this.resetSearch(this.pint_params);
                this.printManage();
            },
            //码单管理删除
            getPintTableDelete(id){
                this.$confirm('是否确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading("/erp/inventory.sheet.print.delete",{ids:[id]},()=>{
                        this.tip('删除成功','success');
                        this.printManage()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getPintRow(row){
                this.selectPintRow=row;
            },
            //码单管理打印
            printConfirm(){
                if(this.selectPintRow.length>1||this.selectPintRow.length<1){
                    this.tip("请选择单条数据","warning")
                    return
                }else{
                    let url = "/printBundle?id=" + this.selectPintRow[0].inventory_ids + "&type=" +this.selectPintRow[0].type+ "&print_id=" +this.selectPintRow[0].id;
                    window.open(url);
                }
            },
            //码单批量修改
            batchPintDel(){
                 if(this.selectPintRow.length<1){
                    this.tip("请选择库存","warning")
                }else{
                     this.$confirm('是否确认删除?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let arr = new Array();
                        for(let i=0;i<this.selectPintRow.length;i++){
                            arr.push(this.selectPintRow[i].id)
                        }
                        this.postFuncLoading("/erp/inventory.sheet.print.delete",{ids:arr},()=>{
                            this.tip('删除成功','success');
                            this.printManage()
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    }).catch(()=>{});
                }
            },
            //码单管理修改
            getPintTableEdit(id,row){
                this.print_params.breed= row.breed;
                this.print_params.date= this.formatTime(row.date+"000");
                this.print_params.user= row.user;
                this.print_params.shipment= row.shipment;
                this.print_params.contract_no= row.contract_no;
                this.print_params.location= row.location;
                this.print_params.species= row.species;
                this.print_params.remark= row.remark;
                this.print_params.type = row.type;
                // this.print_params.inventory_ids = row.inventory_ids;
                this.print_params.id = row.id;
                this.printType = 1;
                this.addPrintManageDialog = true;
            },
            //细码单打印
            printOpen(){
                if(this.selectRow.length<1){
                    this.tip('请选择数据',"warning")
                    return
                }else if(this.selectRow.length==1){
                    this.print_params.breed = this.selectRow[0].breed;
                    this.print_params.contract_no = this.selectRow[0].contract_no;
                }
                let breed =  this.selectRow.map(a=>a.breed)
                let contract_no =  this.selectRow.map(a=>a.contract_no)
                if(this.$isAllEqual(breed)){
                    this.print_params.breed = this.selectRow[0].breed;
                }
                if(this.$isAllEqual(breed)){
                    this.print_params.contract_no = this.selectRow[0].contract_no;
                }
                this.printType = 0;
                this.addPrintManageDialog = true;
            },
            addPrintManage(type){
                if(this.printType==0){
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    this.print_params.type = type;
                    this.print_params.inventory_ids = arr;
                    let time = this.print_params.date;
                    this.print_params.date=this.formatTimeZero(this.print_params.date);
                    this.postFunc("/erp/inventory.sheet.print.add",this.print_params,res=>{
                        this.print_params.date = time;
                        let url = "/printBundle?id=" + arr + "&type=" +type+ "&print_id=" +res.data.data.id;
                        window.open(url);
                    },error=>{
                        this.print_params.date = time;
                        this.tip(error.data.message,"warning")
                    })  
                }else if(this.printType==1){
                    let time = this.print_params.date;
                    this.print_params.date=this.formatTimeZero(this.print_params.date);
                    this.postFunc("/erp/inventory.sheet.print.update",this.print_params,res=>{
                        // this.print_params.date = time;
                        this.addPrintManageDialog = false;
                        this.printManage();
                    },error=>{
                        this.print_params.date = time;
                        this.tip(error.data.message,"warning")
                    })  
                    
                }
            },
            //导出
            exportPrintExcelBill(){
                 if(this.selectPintRow.length>1||this.selectPintRow.length<1){
                    this.tip("请选择单条数据","warning")
                    return
                }
                this.$exportExecl("/erp/inventory.sheet.export","码单导出",{id:this.selectPintRow[0].id})
            },
            originalPrint(type){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    let url = "/printBundle?id=" + arr + "&type=" +type;
                    window.open(url);
                }
            },
            batchOriginal(){
                if(this.selectRow.length>1||this.selectRow.length<1){
                    this.tip("请选择一条数据","warning")
                }else{
                    this.originalId = this.selectRow[0].id;
                    this.dialogVisibleOrigin = true;
                }
            },
            chiBlur(){
                this.continueFlag = false;
                this.postFunc("/erp/inventory.get.cube",{bale_no:this.chiData.bale_no},response=>{
                    this.chiData.original_cube = response.data.data.original_cube;
                    this.lock_status = response.data.data.lock_status;
                    this.continueFlag = true;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            relativeFile(obj){
                this.downLoadFileDialog = !this.downLoadFileDialog;
                if(obj.files!=null){
                    this.downFilesList = obj.files;
                }else{
                    this.downFilesList = '';
                }
            },
            recall(id,row){
                if(row.purchase_return_id==0){
                    this.list.forEach(item=>{
                        if(item.id == id){
                            if(item.isMsg == 1){
                                this.$confirm('该包资源的订单已经收款结算，这里无法撤销，请到销售单那里去做撤回后再操作，谢谢。', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(() => {
                                }).catch(()=>{});
                            }else{
                                this.$confirm('是否确定撤销?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(() => {
                                    this.postFuncLoading("/erp/inventory.order.cancel",{id:id},()=>{
                                        this.tip("撤销成功","success")
                                        this.getList();
                                    },error=>{
                                        this.tip(error.data.message,"warning")
                                    })
                                }).catch(()=>{});
                            }
                        }
                    })
                }else{
                    this.$confirm('是否确定撤销?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                    this.postFuncLoading("/erp/inventory.dhreturn.cancel",{id:id},()=>{
                            this.tip("撤销成功","success")
                            this.getList();
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    }).catch(()=>{});
                }
               
            },
            seeSaleBill(invId,row){
                if(row.purchase_return_id==0){
                    this.postFuncLoading("/erp/inventory.get.order",{id:invId},res=>{
                        this.detailInfo=res.data.data;
                        this.detailInfo.saleInventory_id = invId;
                        this.dialogVisibleSale = true;
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }else{
                    this.scene = 'purchase.return.create';
                    this.isGlobal = true;
                    this.getBillColumn('purchase.return.create');
                    this.postFunc("/erp/purchase.return.info",{id:row.purchase_return_id},res=>{
                        this.listDetail = res.data.data.details;
                        this.return_form_params = res.data.data.info;
                        this.return_form_params.date =  this.formatTime(this.return_form_params.date+"000")
                        this.return_form_params.rec = this.return_form_params.rec==1?true:false;
                        this.newFee = res.data.data.fee;
                        this.purchaseTypeText = '采购退货单'+'('+res.data.data.info.contract_no+')';
                    })
                    this.dialogReturnVisible = true;
                }
            },
            upImgRemove(url){
                this.upImagesList.forEach((item,index)=>{
                    if(item == url){
                        this.upImagesList.splice(index,1)
                    }
                })
            },
            upFileRemove(url){
                this.upFileList.forEach((item,index)=>{
                    if(item.url == url){
                        this.upFileList.splice(index,1)
                    }
                })
            },
            saveImgs(type){
                this.$confirm('是否确认上传?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.upImgObj.images = this.upImagesList;
                    this.upImgObj.append = type;
                    this.postFuncLoading("/erp/inventory.upload.images",this.upImgObj,()=>{
                        this.tip('上传成功','success');
                        this.dialogVisibleImg = false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            bacthUpImg(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    this.upImgObj.kid = arr;
                    if(this.selectRow.length == 1){
                        this.upImagesList = Array.isArray(this.selectRow[0].images)?JSON.parse(JSON.stringify(this.selectRow[0].images)):[];
                    }
                    this.dialogVisibleImg = true;
                    this.isUpImg = 1;
                }
            },
            bacthUpFile(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    this.upFileObj.kid = arr;
                    if(this.selectRow.length == 1){
                        this.upFileList = Array.isArray(this.selectRow[0].files)?JSON.parse(JSON.stringify(this.selectRow[0].files)):[];
                    }
                    this.dialogVisibleFile = true;
                    this.isUpImg = 2;
                }
            },
            saveFile(){
                this.$confirm('是否确认上传?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.upFileObj.files = this.upFileList;
                    this.postFuncLoading("/erp/inventory.upload.files",this.upFileObj,()=>{
                        this.tip('上传成功','success');
                        this.dialogVisibleFile = false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            //赎单日确定
            hoverClickConfirm(){
                let obj = new Object();
                obj.id = this.hoverClickObj.id;
                obj[this.hoverClickObj.key] = this.hoverClickObj.val;
                this.postFuncLoading(this.hoverClickObj.posturl,obj,()=>{
                    this.tip("修改成功","success")
                    this.getList()
                    this.dialogVisibleHoverClick = false;
                })
            },
            exportExcelBill(){
                this.$exportExecl("/erp/inventory.statistic.export","板材库存统计",this.params)
            },
            filterConfirm(){
                if(this.isGlobal){
                    this.getBillColumn()
                }else{
                    this.getList()
                }
            },
            getBillColumn(scene){
                this.filters = [];
                this.postFunc("/erp/company.column.data",{scene:scene},response=>{
                    this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                    this.filters = response.data.data.columns;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //打印标签
            printTip(){
                if(this.selectRow.length<1){
                    this.tip("请选择打印数据","warning")
                }else{
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    let url = "/labelPrint?ids=" + arr+"&field="+this.params.field+"&sort="+this.params.sort;
                    window.open(url);
                }
            },
            //查看组装拆卸
            dialogViewClick(row){
                if(row.type=="ad_id"){
                    this.getBillColumn("assembly.create.column")
                    this.postFunc("/erp/assembly.view",{id:row.row.ad_id},res=>{
                        this.form_params.out.detail=res.data.data.out;
                        this.form_params.in.detail=res.data.data.in;
                        this.form_params.remark=res.data.data.info.remark;
                        this.form_params.order_time = this.formatTime(res.data.data.info.order_time+"000");
                        this.form_params.creator_name = res.data.data.info.creator_name;
                        this.form_params.ad_no = res.data.data.info.ad_no
                        this.zuDialogVisible=true;
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }else if(row.type=="return_id"){
                    this.getBillColumn("return.details")
                    this.postFunc("/erp/inventory.return.view",{id:row.row.id,return_id:row.row.return_id},res=>{
                        this.form_params_record=res.data.data;
                        this.form_params_record.details.forEach((item,index) => {
                            this.form_params_record.details[index].return_cube=this.keepLimit(this.form_params_record.details[index].return_cube)
                            this.form_params_record.details[index].sales_cube=this.keepLimit(this.form_params_record.details[index].sales_cube)
                            this.form_params_record.details[index].out_cube=this.keepLimit(this.form_params_record.details[index].out_cube)
                            this.form_params_record.details[index].sales_price=this.keepPrice(this.form_params_record.details[index].sales_price)
                            this.form_params_record.details[index].totalPrice=this.keepPrice(Number(this.form_params_record.details[index].sales_price)*Number(this.form_params_record.details[index].sales_cube))
                        });
                        this.dialogVisibleRecord=true;
                        this.new_inventory_id = row.row.id;
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }else if(row.type=="move_order_id"){//转库
                        this.getBillColumn("move.storage.out")
                        this.dialogVisiblesTransfer = true
                        this.postFunc("/erp/move.storage.get",{id:row.row.move_order_id},res=>{
                        this.form_params.remark=res.data.data.remark;
                        this.in_warehouse_id = res.data.data.in_warehouse_id;
                        this.warehouse_local = res.data.data.warehouse_local;
                        this.status = res.data.data.status;
                        this.fee_list = res.data.data.fee_list;
                        if(this.status==1){
                            this.status = '已完成'
                        }else{
                            this.status = '待转库'
                        }
                        this.bottom.creator_name = res.data.data.creator_name;
                        this.bottom.out_time = this.formatTime(res.data.data.out_time+"000");
                        this.bottom.transfer_name = res.data.data.transfer_name;
                        this.bottom.inbound_time = this.formatTime(res.data.data.inbound_time+"000");
                        this.form_params.out.detail=res.data.data.out_stocks;
                        this.form_params.in.detail=res.data.data.in_stocks;
                        this.dialogVisibles=true;
                        this.Edit = obj.row.isEdit;
                        this.dels = obj.row.isDelete;
                        this.goodsId = res.data.data.id;
                        this.editid = obj.row.id;
                        this.isCanEdit=false;
                    },()=>{})
                }else if(row.type=="translate_id"){
                    this.getBillColumn("translate.package.in")
                    this.tiltingDialogVisibles = true
                    this.postFunc("/erp/translate.package.info",{id:row.row.translate_id},res=>{
                    this.inventory_sum = [res.data.data.inventory_sum];
                    this.goodsId = res.data.data.id;
                    this.in_warehouse_id = res.data.data.in_warehouse_id;
                    this.warehouse_local = res.data.data.warehouse_local;
                    this.fee_list = res.data.data.fee_list;
                    this.status = res.data.data.status;
                    this.bottom.creator_name = res.data.data.creator_name;
                    this.bottom.tran_date = this.formatTime(res.data.data.tran_date+"000");
                    this.bottom.transfer_name = res.data.data.transfer_name;
                    this.bottom.order_sn = res.data.data.order_sn
                    // this.bottom.inbound_time = this.formatTime(res.data.data.inbound_time+"000");
                    if(res.data.data.inbound_time!=0){
                        this.bottom.inbound_time = this.formatTime(res.data.data.inbound_time+"000")
                    }else{
                        this.bottom.inbound_time = "";
                    }
                    this.form_params.out.detail=res.data.data.old_inventory;
                    this.form_params.in.detail=res.data.data.new_inventory;
                    this.dialogVisibles=true;
                    this.Edit = obj.row.isEdit;
                    this.dels = obj.row.isDelete;
                    this.editid = obj.row.id;
                    this.isCanEdit=false;
                    for(let ke in this.form_params.in.detail){
                        this.form_params.in.detail[ke].in_warehouse = res.data.data.in_warehouse;
                    }
                    this.form_params.remark=res.data.data.remark;
                },()=>{})
                }
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            //跳转成品明细
            openData(){
                sessionStorage.setItem("FINISHED_PRODUCT_DETAILS_ID",this.goodsId)
                this.$root.$children[0].$children[0].addTab({
                    name: '成品明细'+this.goodsId,
                    label: '成品明细',
                    content: 'warehouseRummageDetail'
                });
                this.dialogVisibles = false;
            },
            //品名改变时,销售品名为空
            changesaleBreed(){
                this.editForm.sales_breed='';
                this.editForm.sales_breed_id='';
            },
            getSelectWarehouseList(target){
                this.$getSelectWarehouseList(target,this.params).then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
            addWidth(){
                this.widthObj.widthList.push(null)
            },
            delWidth(ind){
                 this.widthObj.widthList.forEach((item,index)=>{
                    if(index==ind){
                        this.widthObj.widthList.splice(index,1)
                    }
                 })
            },
            widthEdit(){
                let obj = new Object();
                obj.id=this.widthObj.id;
                if(this.widthObj.widthType==2){
                    obj.width=this.widthObj.widthList;
                }else{
                    obj.sales_width=this.widthObj.widthList;
                }
                this.postFuncLoading("/erp/inventory.update.width",obj,()=>{
                    this.tip('修改成功','success');
                    this.dialogVisibleWidth=false;
                    this.getList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //检尺修改START
            chiCheckCube(val){
                this.chiData.sales_cube=Number(val);
            },
            chiEdit(type,go){
                this.continueFlag = false;
                this.postFuncLoading("/erp/inventory.check.cube",this.chiData,()=>{
                    this.continueId = this.chiData.id[0];
                    if(type=="reset"){
                        this.chiData=this.resetJson(this.chiData)
                    }else{
                        this.dialogVisibleChi=false;
                    }
                    this.tip('检尺成功','success');
                    this.getList(false,go)
                    this.dialogVisibleTip = false;
                },error=>{
                    this.continueFlag = true;
                    this.tip(error.data.message,"warning")
                })
            },
            chi(){
                if(this.selectRow.length>1){
                    this.tip("请选择一件库存商品检尺","warning")
                    return;
                }else if(this.selectRow.length==1&&this.selectRow[0].status==5){
                    this.tip("已售资源无法检尺","warning")
                    return;
                }else{
                    if(this.selectRow.length<1){
                        this.dialogVisibleChi=!this.dialogVisibleChi;
                    }else{
                        if(!this.selectRow[0].isCheck){
                            this.tip("选择商品不可检尺","warning")
                            return;
                        }else{
                            let arr = new Array();
                            arr[0] = this.selectRow[0].id;
                            this.lock_status = this.selectRow[0].lock_status
                            this.chiData.id=arr;
                            this.continueId = this.selectRow[0].id;
                            this.chiData.bale_no = this.selectRow[0].bale_no;
                            this.chiData.original_cube = this.selectRow[0].original_cube;
                            this.chiData.check_cube = this.selectRow[0].check_cube==0?'':this.selectRow[0].check_cube;
                            this.chiData.sales_cube = this.selectRow[0].sales_cube;
                            this.dialogVisibleChi=!this.dialogVisibleChi;
                            if(this.selectRow[0].category=="非洲材"){
                                this.isCategoryEdit = true;
                            }
                            setTimeout(() => {
                                document.getElementById('chiCheckCube').focus()
                            }, 0);
                        }
                    }
                }
            },
            openTip(type){
                this.tipType = type;
                this.dialogVisibleTip = !this.dialogVisibleTip;
            },
            
            //检尺修改END
            //百分比修改START
            batchPerEdit(){
                if(this.selectRow.length<1){
                    this.tip("请选择库存商品","warning")
                }else{
                    let flag = true;
                    for(let i=0;i<this.selectRow.length;i++){
                        if(this.selectRow[0].category=="非洲材"){
                            this.tip("请点开销售总宽度修改销售立方","warning")
                            return
                        }
                        if(this.selectRow[i].status==5){
                            this.tip("已售资源无法百分比修改","warning")
                            this.flag=false;
                            return;
                        }
                        if(!this.selectRow[i].isPercentage){
                            flag = false;
                            this.tip("选择商品中有不可修改项","warning")
                            return;
                        }else{
                            this.perIds.push(this.selectRow[i].id)
                        }
                    }
                    if(flag){
                        this.perType=3;
                        this.dialogVisiblePer=true;
                    }
                }
            },
            PerEdit(){
                if(this.perType==3){
                    this.perData.id=this.perIds;
                }
                this.postFuncLoading("/erp/inventory.proportion",this.perData,()=>{
                    this.tip('百分比修改成功','success');
                    this.dialogVisiblePer=false;
                    this.getList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //百分比修改END
            //修改库存START
            batchEdit(){
                if(this.selectRow.length<1){
                    this.tip("请选择库存","warning")
                }else{
                    let flag = true;
                    this.batchFlag = true;
                    for(let i=0;i<this.selectRow.length;i++){
                        // if(this.selectRow[i].status==5){
                        //     this.tip("已售资源无法修改","warning")
                        //     this.flag=false;
                        //     return;
                        // }
                        if(!this.selectRow[i].isEdit){
                            if(!this.editStock){
                                flag = false;
                                this.tip("选择商品中有不可修改项","warning")
                                return;
                            }else{
                                this.editIds.push(this.selectRow[i].id)
                                this.editForm.original_cube_copy = this.editForm.original_cube?this.editForm.original_cube:'';
                                this.editStockLimit = true;
                            }
                        }else{
                            this.editIds.push(this.selectRow[i].id)
                        }
                    }
                    if(flag){
                        this.editType=3;
                        this.selectRow.forEach(item=>{
                            if(item.category=="北美材"){
                                this.editCategory = true;
                            }
                            if(item.category=="非洲材"){
                                this.isCategory = 1;
                                if(item.width.length>1){
                                    this.mixedBag = true;
                                    this.tip("选择商品中有混包数据","warning")
                                }
                            }
                        })
                        this.dialogVisible=true;
                    }
                }
            },
            edit(){
                if(this.editType==3){
                    this.editForm.id=this.editIds;
                }
                if(!this.editForm.original_cube_copy){
                    this.editForm.original_cube_copy = "";
                }
                if(!this.editForm.original_cube){
                    this.editForm.original_cube = "";
                }
                let timeA = this.formatTimeZero(this.editForm.inbound_time);
                let timeB = this.formatTimeZero(this.originalInbound);
                if(this.editForm.original_cube_copy!=this.editForm.original_cube){
                    this.$confirm('码单立方有修改是否确认提交?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.editFunc()
                    }).catch(()=>{});
                }else if(timeA != timeB){
                    this.$confirm('入库日期修改不会同步到库存结余，且会导致仓储费计算不正确，是否确认操作？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.editFunc()
                    }).catch(()=>{});
                }else{
                    this.editFunc()
                }

            },
            editFunc(){
                if(this.isCategory ==1&&this.isCategoryNumber == 0){
                    this.salesEditDialog=true;
                    return
                }
                let url = "";
                if(this.editType==2){
                    url = "/erp/inventory.update.one";
                }else{
                    url = "/erp/inventory.update";
                }
                if(this.editType==3&&this.isCategory ==1){
                    this.editForm.sync_width = this.sync_width==true?1:0;
                }
                this.editForm.inbound_time=this.formatTimeZero(this.editForm.inbound_time)
                this.postFuncLoading(url,this.editForm,()=>{
                    this.tip('修改成功','success');
                    this.dialogVisible=false;
                    this.salesEditDialog = false;
                    this.getList()
                },error=>{
                    this.tip(error.data.message,"warning")
                    this.editForm.inbound_time = time;
                },()=>{
                    this.editForm.inbound_time = time;
                })
            },
            //是否确定修改同步
            synchronization(){
                this.isCategoryNumber = 1;
                this.editFunc();
            },
            getTableEdit(id,row){
                this.inStockWarehouse(row.warehouse_id, false, () => {
                    this.editForm = this.$cloneJson(row);
                    this.editForm.original_cube_copy = this.editForm.original_cube;
                    this.editForm = this.clearZero(this.editForm);
                    this.originalInbound = row.inbound_time;
                });
                if(row.category=="北美材"){
                    this.editCategory = true;
                }
                if(row.width.length>0){
                    this.originalGraying = true;
                }
                if(row.width.length>1){
                    this.mixedBag = true;
                }
                this.dialogVisible=true;
            },
            //修改库存END
            batchDel(){
                if(this.selectRow.length<1){
                    this.tip("请选择库存","warning")
                }else{
                    let flag = true;
                    let arr = new Array();
                    for(let i=0;i<this.selectRow.length;i++){
                        if(this.selectRow[i].status==5){
                            this.tip("已售资源无法删除","warning")
                            this.flag=false;
                            return;
                        }
                        if(!this.selectRow[i].isDelete){
                            flag = false;
                            this.tip("选择商品中有不可删除项","warning")
                            return;
                        }else{
                            arr.push(this.selectRow[i].id)
                        }
                    }
                    if(flag){
                        this.del(arr)
                    }
                }
            },
            del(ids){
                this.$confirm('是否确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading("/erp/inventory.delete",{id:ids},()=>{
                        this.tip('删除成功','success');
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            reset(){
                this.start_time=null;
                this.end_time=null;
                this.start_out_time='';
                this.end_out_time='';
                this.params=this.resetSearch(this.params)
                this.params.check_status=999;
                this.params.bale_status=[1];
                // this.is_like=false;
                this.getList();
            },
            getList(flag,go){
                if(flag){
                    this.params.page = 1;
                }
                this.params.is_like = this.is_like;
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                this.params.start_out_time=this.formatTimeZero(this.start_out_time);
                this.params.end_out_time=this.formatTimeZero(this.end_out_time);
                this.tableLoading = true;
                this.$postColumnList(`/erp/inventory.statistic`,this.params,res=>{                    
                    this.last_page=parseInt(res.data.data.data.last_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.totalObj=res.data.data.total;
                    this.totalObj.original_cube=this.keepLimit(this.totalObj.original_cube)
                    this.totalObj.sales_cube=this.keepLimit(this.totalObj.sales_cube)
                    this.list=res.data.data.data.data;
                    this.list.forEach((item,index)=>{
                        if(item.inbound_time&&item.inbound_time!=0){
                            this.list[index].inbound_time = this.formatTimeSecond(item.inbound_time*1000) 
                        }else{
                            this.list[index].inbound_time ='';
                        }
                        if(item.out_time!=0){
                            this.list[index].out_time = this.formatTime(item.out_time+"000")
                        }else{
                            this.list[index].out_time = "";
                        }
                        if(item.move_in_time!=0){
                            this.list[index].move_in_time = this.formatTime(item.move_in_time+"000")
                        }else{
                            this.list[index].move_in_time = "";
                        }
                        if(item.ad_id!=0){
                            if(item.ad_type==1){
                                item.isDialogViewAdIdHe=true;
                            }
                            if(item.ad_type==2){
                                item.isDialogViewAdIdChai=true;
                            }
                        }
                        item.baseColor = "";
                        if(item.check_status == 0){
                            item.baseColor = "#E37D16";
                        }
                        if(item.return_id!=0){
                            item.isDialogViewReturnId=true;
                        }
                        if(item.translate_id!=0){
                            item.isDialogViewTranslate_id=true;
                        }
                        if(item.move_order_id!=0){
                            item.isDialogViewMove_order_id=true;
                        }
                        if(item.status==1&&item.lock_status==0){
                            item.baseColor="#222";
                        }else if(item.status==2){
                            item.baseColor="#155BD4";
                        }else if(item.status==3){
                            item.baseColor="#B400FF";
                        }else if(item.status==4){
                            item.baseColor="#007B04";
                        }else if(item.status==1&&item.lock_status==1){
                            item.baseColor="#FF0000";
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                    })
                    if(go){
                        go()
                    }
                    this.continueFlag = true;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            getPrintPage(obj){
                this.pint_params.page=obj.currentpage;
				this.pint_params.per_page=obj.pagesize;
            },
            hoverClick(row){
                this.hoverClickObj.id = row.id;
                if(row.hoverClickName == 'redemption_day'){
                    this.hoverClickObj.val = row.redemption_day;
                    this.hoverClickObj.title = "赎单日";
                    this.hoverClickObj.posturl = "/erp/inventory.update.redemption";
                    this.hoverClickObj.key = "redemption_day";
                }else if(row.hoverClickName == 'remark'){
                    this.hoverClickObj.val = row.remark;
                    this.hoverClickObj.title = "备注";
                    this.hoverClickObj.posturl = "/erp/inventory.update.remark";
                    this.hoverClickObj.key = "remark";
                }else if(row.hoverClickName == 'remark_1'){
                    this.hoverClickObj.val = row.remark_1;
                    this.hoverClickObj.title = "备注1";
                    this.hoverClickObj.posturl = "/erp/inventory.update.remark1";
                    this.hoverClickObj.key = "remark_1"
                }else if(row.hoverClickName == 'storage_location'){
                    this.hoverClickObj.val = row.storage_location;
                    this.hoverClickObj.title = "库位";
                    this.hoverClickObj.posturl = "/erp/inventory.update.warehouse.local";
                    this.hoverClickObj.key = "storage_location"
                }
                this.dialogVisibleHoverClick = true;
            },
            rowClick(obj){
                if (['original_width_total', 'sales_width_total'].includes(obj.name)) {
                    this.widthSaleInventoryId = this.widthObj.id = obj.id;
                    if (obj.name === "original_width_total") {
                        this.widthObj.widthType = 2;
                        this.widthObj.widthList = obj.row.width;
                        this.isHidePer = true;
                        this.issetper = false;
                    } else {
                        this.widthObj.widthType = 3;
                        this.widthObj.widthList = obj.row.sales_width;
                        this.isHidePer = false;
                        this.issetper = true;
                    }
                    this.isCanWidthEdit = obj.row.isEdit;
                    this.dialogVisibleWidth = true;
                }
                if(obj.name =='cost'){
                    this.postFunc('/erp/inventory.cost.logs',{inventory_id:obj.id},res=>{
                        this.costLogDetailDialog = true;
                        let resD = res.data.data;
                        this.costLogDetailList = Array.isArray(resD) ? resD : [];
                    })
                }
                if(obj.name =='warehouse_cost'){
                    this.postFunc('/erp/warehouse.cost.logs',{inventory_id:obj.id},res=>{
                        this.costWarehouseDialog = true;
                        let resD = res.data.data;
                        this.costWarehouseList = Array.isArray(resD) ? resD : [];
                    })
                }
                if(obj.name == 'finance_cost'){
                    this.postFunc('/erp/finance.cost.logs',{inventory_id:obj.id},res=>{
                        this.costLogDetailDialogB = true;
                        let resD = res.data.data.data;
                        this.costLogDetailListB.forEach((item,index)=>{
                           this.costLogDetailListB[index].fee_date = this.formatTime(item.fee_date+"000");
                        })
                        this.costLogDetailListB = Array.isArray(resD) ? resD : [];
                        this.costLogtotal = res.data.data.total;
                    })
                }
            },
            getTableDelete(id){
                this.del([id])
            },
            //表格排序
            sortTable(sort){
                this.params.field = sort.order ? sort.prop:'';
                this.params.sort = sort.order == "ascending"?"asc":sort.order == "descending"?"desc":"";
                this.getList();
            },
            getRow(row){
                this.selectRow=row;
                let number = 0;
                this.selectRow.forEach(item=>{
                    number += Number(item.sales_cube)
                })
                this.selectCube = this.keepLimit(number)
            },
            amend(){
                this.recChanges = !this.recChanges;
                this.f_rec = this.return_form_params.rec;
                this.rec_params.rec = this.return_form_params.rec==1?true:false;
                this.rec_params.tax_rate = this.return_form_params.tax_rate;
            },
            //期初导入
            handleSuccess(res) {
                if(this.isUpImg == 1){
                    this.upImagesList.push(res.data.base_url)
                }else if(this.isUpImg == 2){
                    let obj = new Object();
                    obj.url = res.data.base_url;
                    obj.name = res.data.filename.substring(res.data.filename.lastIndexOf("/")+1,res.data.filename.length)
                    this.upFileList.push(obj)
                }else{
                    this.file_url = res.data.base_url;
                }
				this.$refs.upload_path.clearFiles();
                this.tip('文件上传成功', 'success');
                //this.importFile();
            },
            beforeUpload(file) {
                this.file = file;
                return this.getOss();
            },
            handleImagesSuccess(file){
                this.upImagesList.push(file.data.base_url);
            },
            importFile(){
                let url = this.downLoadExeclType=="init_africa_stock"?'/erp/import.init.africa':this.downLoadExeclType=="init_ds_stock"?'/erp/import.init.ds':'/erp/import.init.america';
                this.analysis(url,this.file_url,"","","",response=>{
                    if (response.data.code == 0) {
                        this.tip("上传成功","success")
                        this.getList()
                        this.importDialogVisible=false;
                    }else{
                        this.tip(response.data.message,"warning")
                    }
                })
            },
            downTemplete(){
                this.exportFile(this.downLoadExeclType,"","","",response=>{
                    let title = this.downLoadExeclType=="init_africa_stock"?'非洲材':this.downLoadExeclType=="init_ds_stock"?'国标/非洲材':'板材';
					const content = response.data;
					const blob = new Blob([content], {type: response.headers['content-type']});
					const fileName = title+'期初导入'+this.getDownloadTempleteTime(new Date())+'.xlsx';
					if ('download' in document.createElement('a')) { // 非IE下载
						const elink = document.createElement('a');
						elink.download = fileName;
						elink.style.display = 'none';
						elink.href = URL.createObjectURL(blob);
						document.body.appendChild(elink);
						elink.click();
						URL.revokeObjectURL(elink.href); // 释放URL 对象
						document.body.removeChild(elink);
					} else { // IE10+下载
						navigator.msSaveBlob(blob, fileName);
					}
                })
            },
            getOss(){
                let self = this;
                return new Promise((resolve, reject) =>{
                    window.axios.post(window.oss_url+"/tool/v1/oss.policy.get",{
                        operate_code : "shop-excel"
                    }).then((response) => {
                        if(response.data.code == 0){
                            self.oss = response.data.data;
                            this.upload_data = {
                                name: self.file.name,
                                key : self.oss.dir + "${filename}",
                                policy : self.oss.policy,
                                OSSAccessKeyId : self.oss.accessid,
                                success_action_status : "200",
                                callback : self.oss.callback,
                                signature : self.oss.signature,
                                'Cache-Control' : self.oss.cache_control,
                            }
                            resolve();
                        }
                    }).catch(()=>{
                        reject();
                    })
                })
            }
        },
        components:{
            tabletem,
            pagination,
            relativeFile,
            originalManage,
            saleBillBase
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "pint_params.page":function(){
                this.printManage();
            },
            "pint_params.per_page":function(){
                this.printManage();
            },
            "dialogVisible":function(val){
                if(!val){
                    this.editForm=this.resetJson(this.editForm);
                    this.editIds=[];
                    this.editType=2;
                    this.editStockLimit = false;
                    this.batchFlag = false;
                    this.editCategory = false;
                    this.isCategory = 0;
                    this.sync_width = false;
                    this.isCategoryNumber = 0;
                    this.locationList = [];
                    this.originalGraying = false;
                    this.mixedBag = false;
                }
            },
            "dialogVisiblePer":function(val){
                if(!val){
                    this.perData=this.resetJson(this.perData);
                    this.perData.id=[];
                    this.perIds = [];
                }
            },
            "dialogVisibleChi":function(val){
                if(!val){
                    this.chiData=this.resetJson(this.chiData)
                    this.continueId = "";
                    this.isCategoryEdit = false;
                }
            },
            "dialogVisibleWidth":function(val){
                if(!val){
                    this.widthObj={id:"",widthList:[],widthType:2}
                }
            },
            "dialogVisibleHoverClick":function(val){
                if(!val){
                    this.redemptionEdit = {id:"",redemption_day:"",};
                }
            },
            "dialogVisibleImg":function(val){
                if(!val){
                    this.isUpImg = 0;
                    this.upImgObj = {kid:[],images:[]}
                    this.upImagesList = [];
                }
            },
            "dialogVisibleFile":function(val){
                if(!val){
                    this.isUpImg = 0;
                    this.upFileObj = {kid:[],files:[]}
                    this.upFileList = [];
                }
            },
            "dialogVisibleOrigin":function(val){
                if(!val){
                    this.originalId = "";
                }
            },
            "dialogVisibleSale":function (val) {
                if (!val) {
                    this.detailInfo = {};
                    this.newFee = [];
                }
            },
            "decimalShow":function(val){
                if(val){
                    this.decimalGet();
                }
            },
            // "addPrintManageDialog":function(val){
            //     if(!val){
            //         this.print_params={
            //             breed:'',
            //             contract_no:'',
            //             date:'',
            //             location:'',
            //             shipment:'',
            //             species:'',
            //             user:'',
            //             remark:'',
            //         }
            //         this.printType ='';
            //     }
            // }
        }
    }
</script>
